//ScreensHomeForm

//IMPORTS
// #region IMPORTS
import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { ComponentsPedidoFiltroForm } from '../components/Filtro/PedidoFiltro';
import { DataView } from 'primereact/dataview';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { PedidoPortalService } from '../service/PedidoPortal';
import { Paginator } from 'primereact/paginator';
import axios from 'axios';
import { ServiceLogin } from '../service/Login';
import moment from 'moment/min/moment-with-locales';
import print from 'print-js';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { ServiceApi } from '../service/Api';
import { getViewerAccessKey, getViewerAuthHeader, persistViewerAccessKey } from '../service/ViewerAuth';
import { MedicoService } from '../service/Medico';
import { Sidebar } from 'primereact/sidebar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputMask } from 'primereact/inputmask';
import { GaleriaImagens } from '../screens/Imagens/GaleriaImagens';
import { GaleriaExternos } from '../screens/Imagens/GaleriaExternos';
import { HistoricoAceiteLGPD } from '../service/HistoricoAceiteLGPD';
import { listarJob, BuscarImagensLista } from '../service/ServiceJob';
import './DataTableDemo.css';
import { GaleriaServices } from '../service/GaleriaServices';
import { ComponentsAppSplash } from '../components/App/Splash';
import { Menu } from 'primereact/menu';
import 'primereact/resources/themes/saga-blue/theme.css';
import { Calendar } from 'primereact/calendar';
import { SplitButton } from 'primereact/splitbutton';
import ModalMensagem from '../components/Avisos/ModalMensagem';
import imgErro from '../images/Icons/error-svgrepo-com.svg'; // ou qualquer outra imagem de erro
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import JSZip from 'jszip';
import { AutoComplete } from 'primereact/autocomplete';
import md5 from 'md5';
import { InputSwitch } from 'primereact/inputswitch';
import { CameraCapture } from '../components/CameraCapture/CameraCapture';
import StudyCard from '../components/StudyCard/StudyCard';
import ExternalStudyCard from '../components/ExternalStudyCard/ExternalStudyCard';
import StudyContentModal from '../components/StudyContentModal/StudyContentModal';
import i18n from '../i18n';

//images
import calendar from '../images/Icons/calendar.svg';
import calendarWhite from '../images/Icons/calendar-white.svg';
import hospital from '../images/Icons/lucide_hospital.svg';
import doctor from '../images/Icons/hugeicons_doctor.svg';
import downloadImg from '../images/Icons/Download-image.svg';
import downloadDicomZip from '../images/Icons/Icone-DicomZip.svg';
import keyImg from '../images/Icons/key.svg';

import share from '../images/Icons/Share-icon.svg';
import printIcon from '../images/Icons/Print-icon.svg';
import imagedashboard from '../images/Icons/mage_dashboard.svg';
import iconeExamesExternos from '../images/Icons/icone-exames-externos.svg';
import iconeExamesExternosBranco from '../images/Icons/icone-exames-externos-branco.svg';
import icoDowndloadBranco from '../images/Icons/icone-download-image-branco.svg';
import icoPdfBranco from '../images/Icons/icone-pdf-branco.svg';
import icoCompartilharBranco from '../images/Icons/icone-compartilhar-branco.svg';
import icoImpressoraBranco from '../images/Icons/icone-impressora-branco.svg';
import icoBaixarZip from '../images/Icons/Icone-baixar-zip.svg';
import iconeProntuario from '../images/Icons/iconeProntuario.svg';
import iconeAmpulheta from '../images/Icons/icone-ampulheta.svg';
import iconeCorreto from '../images/Icons/icone-correto.svg';
import { ServiceConfig } from './../service/Config';

import viewerIcon_principal from '../images/Icons/icone-viewer-branco.svg';
import galeryIcon_principal from '../images/Icons/image_dashboard_white.svg';

import viewerIcon_secundario from '../images/Icons/icone-viewer-azul.svg';
import galeryIcon_secundario from '../images/Icons/mage_dashboard.svg';

var createReactClass = require('create-react-class');

// #endregion

// CONSTS
// #region CONSTS
let cntPgr = 0;
let pgrBarCont = null;

const pedidoFiltro = {
  Prontuario: null,
  PacienteId: 0,
  PacienteNome: '',
  AcNumber: '',
  Prontuario: '',
  DataInicial: '',
  DataFinal: '',
  Modalidades: [],
  //Unidades:[{Id : 1,Nome : '',}, {Id : 2,Nome : '',},{Id : 3,Nome : '',}],
  Unidades: [],
  PageIndex: 0,
  PageCount: 5,
  Revisado: null,
  Sort: null,
  MedicoSolicitanteFiltro: null,
  MedicoExecutanteFiltro: null,
  ConvenioId: 0,
};

const listPrazo = [
  { label: '8h', value: '8' },
  { label: '12h', value: '12' },
  { label: '24h', value: '24' },
  { label: '48h', value: '48' },
];

const defaultValidadeCompartilhamento = '8h';

// fora da classe, no topo do arquivo (recomendado)
const periodoOptions = [
  { label: i18n.t('PORTAL.FILTER.CUSTOM'), value: 'personalizado' },
  { label: i18n.t('PORTAL.FILTER.LAST_30_DAYS'), value: 'ultimos30' },
  { label: i18n.t('PORTAL.FILTER.LAST_90_DAYS'), value: 'ultimos90' },
];

// Auto Heigth
const autoHeigth = {
  height: window.innerHeight - 100 + 'px',
};

const autoHeigthLista = {
  textAlign: 'left',
};

const dataAtual = new Date();

axios.interceptors.request.use(
  config => {
    if (config.url.includes('studies')) {
      const authHeader = getViewerAuthHeader();
      if (authHeader) config.headers.Authorization = authHeader;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// #endregion

// UTILS
// #region UTILS
const getAttrs = (object, tagName) => {
  var doc = document.createElement('div');
  doc.innerHTML = object;

  const item = doc.getElementsByTagName(tagName)[0];
  return [].slice.call(item.attributes).reduce((attrs, element) => {
    attrs[element.name] = element.value;
    return attrs;
  }, {});
};

// #endregion

//COMPONENTS AUXILIARES
//#region COMPONENTS AUXILIARES
const ComponentIframe = createReactClass({
  render: function () {
    return (
      <div style={{ height: '75vh' }}>
        <iframe {...getAttrs(this.props.iframe, 'iframe')} />
      </div>
    );
  },
});

const ComponentEmbed = createReactClass({
  render: function () {
    return (
      <div style={autoHeigth}>
        <embed key={this.props.id} {...getAttrs(this.props.embed, 'embed')} />
      </div>
    );
  },
});

// #endregion

//METHODS
//#region METHODS

//Barra de progresso de Download
function updateProgress(oEvent) {
  clearInterval(pgrBarCont);
  if (oEvent.lengthComputable) {
    var percentComplete = oEvent.loaded / oEvent.total;
    percentComplete = percentComplete * 100 + '%';
    let elProgresBar = document.getElementById('pgrBar');
    elProgresBar.setAttribute('style', 'display:block; width:' + percentComplete);
  }
}
function transferComplete(evt) {
  clearInterval(pgrBarCont);
  viewPgr('none');
}
function transferFailed(evt) {
  clearInterval(pgrBarCont);
  viewPgr('none');
  alert(i18n.t('PORTAL.MESSAGE.DOWNLOAD_ERROR'));
}
function viewPgr(value) {
  let elProgresBar = document.getElementById('pgrBar');
  elProgresBar.setAttribute('style', 'display:' + value + ';');
}
function viewPgrContinuous() {
  cntPgr++;
  if (cntPgr == 101) {
    cntPgr = 0;
  }
  let percentComplete = cntPgr + '';
  let elProgresBar = document.getElementById('pgrBar');
  elProgresBar.setAttribute('style', 'display:block; width:' + percentComplete);
}
//Fim barra de progresso de Download

//#endregion

class ScreensHomeForm extends Component {
  //CONSTRUCTOR
  //#region CONSTRUCTOR
  constructor() {
    super();

    const auth = JSON.parse(sessionStorage.getItem('auth') || '{}');
    const isAcessoCompartilhado = !!auth.TokenPortal;

    this.tipoCompartilhamento = [
      { name: ' WhatsApp', key: 0 },
      { name: ' Email', key: 1 },
    ];

    this.state = {
      paciente: '',
      totalPedidos: 0,
      pedidos: [],
      pedidosExternos: [],
      pedidosCombinados: [],
      layout: 'list',
      selectedPedido: null,
      visible: false,
      sortKey: null,
      sortOrder: null,
      sort: 'recentes',
      rows: 5,
      first: 0,
      Total: 0,
      TotalPedidosExternos: 0,
      panelImageVisible: false,
      panelImageJpegVisible: false,
      panelVisible: false,
      panelLaudoVisible: false,
      panelAnexoVisible: false,
      imagensVinculadas: [],
      caminhoServico: '',
      servicoImagemPortal: '',
      popupImagem: null,
      isMedico: false,
      isExecutante: false,
      emailCompartilhar: '',
      celCompartilhar: '',
      prazoValue: '8',
      pacienteId: 0,
      visibleDialog: false,
      componentImagens: '',
      visibleDialogComentario: false,
      isMobile: false,
      isFullScreen: false,
      modalConfirmaImpressao: false,
      modalImagemOutroPedido: false,
      modalAnexo: false,
      listaAnexos: null,
      Viewer: '',
      viewerSrc: null,
      onPositionScroll: false,
      possuiJob: false,
      filtroSelecionado: { value: 'recentes' },
      mostrarFiltro: false,
      periodoSelecionado: 'ultimos30',
      diasPesquisaInicialAoLogarMedico: 0,
      dataFinal: dataAtual,
      dataInicial: (() => {
        const date = new Date();
        date.setDate(date.getDate() - 30);
        return date;
      })(),
      modalidadeSelecionada: [],
      nomeExame: '',
      girando: false,
      dataInicialInvalida: false,
      dataFinalInvalida: false,
      modalErroVisivel: false,
      mensagemErro: '', // mensagem que vai aparecer na modal
      imagemPreviewUrl: null,
      imagemCarregada: false,
      baixandoDicomZip: false,
      dialogDicomZip: false,
      progressoDicomZip: 0,
      isMobile: window.innerWidth < 850,
      procedimentoSelecionadoId: null,

      //USUARIO
      usuariologado: 0,

      // itens do pedido selecionado antes de abrir a modal de imagem em outro pedido
      pedidoComImagemVinculadaMedicoExecutante: {},
      pedidoComImagemVinculadaMedicoRevisor: {},
      pedidoComImagemVinculadaId: null,

      //Parecer médico
      listaParecer: [],
      parecerId: 0,
      parecerTexto: '',
      parecerDataCadastro: null,
      parecerPrioridade: 0,
      UsuarioId: 0,
      parecerCarregado: false,

      //Exames externos:
      pesquisarExamesExternos: isAcessoCompartilhado ? false : true,
      modalExamesExternosVisivel: false,
      descricaoExame: '',
      localExameExterno: '',
      dataExameExterno: '',
      medicoSolicitanteExameExterno: '',
      crmMedicoSolicitanteExameExterno: '',
      arquivosSelecionados: [],
      pacienteId: '',
      erroCamposObrigatorios: false,
      erroArquivos: false,
      arquivosEnviadosViaUpload: false,
      zipDicom: null,
      caminhopastaDicomExameExterno: '',
      zipandoDicom: false,
      resultadoInclusaoVisivel: false,
      resultadoInclusaoMensagem: '',
      resultadoInclusaoTipo: 'sucesso', // ou 'erro'
      arquivosSelecionados: [],
      procedimentosSugeridos: [],
      arquivosDialogOpen: false,
      pedidoSelecionadoArquivos: null,
      anexosDoPedido: [],
      exibirbotoesmodal: true,

      //Modal
      modalOpcoesVisivel: false,
      pedidoModalOpcoes: null,
      modalOpcaoSelecionada: null,
      laudoCarregando: false,
      laudoPdfData: null,
      formaEnvio: 'whatsapp',
      validadeSelecionada: defaultValidadeCompartilhamento,
      existeAnexo: false,
      validades: [
        { name: '8 horas', value: '8h' },
        { name: '24 horas', value: '24h' },
        { name: '72 horas', value: '72h' },
      ],

      mostrarModalAcoesMobile: false,

      selectedCompartilhamento: this.tipoCompartilhamento[0],

      isAcessoCompartilhado,

      isLoading: true,

      //Configuracoes
      // Labels
      labelBotaoViewer: '',
      labelBotaoGaleria: '',
      labelBotaoBaixarDicom: '',
      labelBotaoLaudo: '',
      labelBotaoImprimirLaudo: '',
      labelBotaoBaixarLaudoPdf: '',
      labelBotaoAnexos: '',
      labelBotaoParecer: '',
      labelInfoAcNumber: '',
      labelInfoUnidade: '',
      labelInfoData: '',
      labelInfoMedSolicitante: '',
      labelInfoMedExecutante: '',
      labelInfoMedRevisor: '',
      labelBotaoCompartilhar: '',
      lblbtnDownloadVisualizador: '',
      lblbtnDownloadDicomZip: '',

      // Status Labels
      labelStatusProcessamentoPaciente: '',
      labelStatusAguardandoPaciente: '',
      labelStatusLiberadoPaciente: '',

      labelStatusProcessamentoMedico: '',
      labelStatusAguardandoMedico: '',
      labelStatusLiberadoMedico: '',

      // Paciente - Botoes
      botaoViewerAtivoPaciente: false,
      botaoGaleriaAtivoPaciente: false,
      botaoBaixarImagensAtivoPaciente: false,
      botaoLaudoAtivoPaciente: false,
      botaoImprimirLaudoAtivoPaciente: false,
      botaoCompartilharAtivoPaciente: false,
      botaoAnexosAtivoPaciente: false,
      acaoBaixarImagens_visualizador_Paciente: false,
      acaoBaixarImagens_dicomZip_Paciente: false,

      // Paciente - Infos
      infoAcNumberAtivoPaciente: false,
      infoProntuarioAtivoPaciente: false,
      infoDataAtivoPaciente: false,
      infoUnidadeAtivoPaciente: false,
      infoMedSolicitanteAtivoPaciente: false,
      infoMedExecutanteAtivoPaciente: false,
      infoMedRevisorAtivoPaciente: false,

      // Paciente - Acoes
      acaoPrincipalBotaoImagensPaciente: '',
      acaoPrincipalThumbnailImagensPaciente: '',
      statusAtivoPaciente: false,

      //PacienteExamesExternos
      botaoIncluirExamesAtivoPaciente: false,
      habilitarEnvioDicomExamesExternos: false,

      // Médico - Botoes
      botaoViewerAtivoMedico: false,
      botaoGaleriaAtivoMedico: false,
      botaoBaixarImagensAtivoMedico: false,
      botaoLaudoAtivoMedico: false,
      botaoImprimirLaudoAtivoMedico: false,
      botaoCompartilharAtivoMedico: false,
      botaoAnexosAtivoMedico: false,
      botaoParecerAtivoMedico: false,
      botaoIncluirExamesAtivoMedico: false,

      acaoBaixarImagens_visualizador_Medico: false,
      acaoBaixarImagens_dicomZip_Medico: false,

      // Médico - Infos
      infoAcNumberAtivoMedico: false,
      infoProntuarioAtivoMedico: false,
      infoDataAtivoMedico: false,
      infoUnidadeAtivoMedico: false,
      infoMedSolicitanteAtivoMedico: false,
      infoMedExecutanteAtivoMedico: false,
      infoMedRevisorAtivoMedico: false,

      // Médico - Acoes
      acaoPrincipalBotaoImagensMedico: '',
      acaoPrincipalThumbnailImagensMedico: '',
      statusAtivoMedico: false,

      // Geral
      tempoInatividade: '30m',
      pesquisa_Inicial_Exames_Paciente: 'Fixo',
      usarRangeDataPaciente: false,
      exibir_apenas_pedidos_revisados_portal: false,
      //

      pedidoSelecionadoAtual: '',

      configDB: '',
    };

    this.galeriaServices = new GaleriaServices();
    this.pedidoservice = new PedidoPortalService();
    this.itemTemplate = this.itemTemplate.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.pedidoSelecionado = 0;

    this.inputPastaRef = React.createRef();
    this.handleSelecionarPastaDicom = this.handleSelecionarPastaDicom.bind(this);
    this.handleClickSelecionarPastaDicom = this.handleClickSelecionarPastaDicom.bind(this);

    this.menuRef = React.createRef();

    this.menuFiltroRef = React.createRef();

    this.setFiltro = filtro => {
      this.setState(
        {
          filtroSelecionado: filtro,
          sort: filtro.value,
          first: 0,
          isLoading: true,
        },
        () => {
          pedidoFiltro.Sort = this.mapSortValue(filtro.value);
          pedidoFiltro.PageIndex = 0;
          this.onPageChange({
            first: 0,
            rows: this.state.rows,
            forceSort: this.mapSortValue(filtro.value),
          });
        }
      );
    };

    this.FiltroDropdown = () => {
      return (
        <div className="relative inline-block">
          <Button
            className="btn-sorter"
            label={this.getSortOptionLabel(this.state.filtroSelecionado.value)}
            icon="pi pi-chevron-down"
            iconPos="right"
            onClick={e => this.menuFiltroRef.current.toggle(e)}
          />
          <Menu
            className="results-header__sort-menu"
            model={this.getSortMenuItems()}
            popup
            ref={this.menuFiltroRef}
          />
        </div>
      );
    };
  }

  getSortOptionLabel = value => {
    const { t } = this.props;
    const labels = {
      recentes: t('PORTAL.FILTER.NEWEST'),
      antigos: t('PORTAL.FILTER.OLDEST'),
      procedimento: t('PORTAL.FILTER.PROCEDURE'),
    };

    return labels[value] || t('PORTAL.FILTER.NEWEST');
  };

  getSortMenuItems = () => [
    {
      label: this.getSortOptionLabel('recentes'),
      command: () => this.setFiltro({ value: 'recentes' }),
    },
    {
      label: this.getSortOptionLabel('antigos'),
      command: () => this.setFiltro({ value: 'antigos' }),
    },
    {
      label: this.getSortOptionLabel('procedimento'),
      command: () => this.setFiltro({ value: 'procedimento' }),
    },
  ];

  getAttachmentTypeLabel = tipoAnexo => {
    const { t } = this.props;
    const labels = {
      0: t('PORTAL.ATTACHMENT_TYPE.NORMAL'),
      1: t('PORTAL.ATTACHMENT_TYPE.DIAGNOSTIC'),
      2: t('PORTAL.ATTACHMENT_TYPE.ANAMNESIS'),
      3: t('PORTAL.ATTACHMENT_TYPE.MEDICAL_REQUEST'),
      4: t('PORTAL.ATTACHMENT_TYPE.MODEL_3D'),
    };

    return labels[tipoAnexo] || '';
  };

  getPriorityLabel = prioridade => {
    const { t } = this.props;

    switch (prioridade) {
      case 'Alta':
        return t('PORTAL.PRIORITY.HIGH');
      case 'Média':
        return t('PORTAL.PRIORITY.MEDIUM');
      case 'Baixa':
        return t('PORTAL.PRIORITY.LOW');
      default:
        return t('PORTAL.PRIORITY.NONE');
    }
  };

  getModalOpcaoLabel = opcao => {
    const { t } = this.props;
    const labels = {
      Viewer: t('PORTAL.MODAL.VIEWER'),
      Galeria: t('PORTAL.MODAL.GALLERY'),
      Laudo: t('PORTAL.CARD.REPORT'),
      Anexos: t('PORTAL.CARD.ATTACHMENTS'),
      Parecer: t('PORTAL.CARD.MEDICAL_OPINION'),
      Arquivos: t('PORTAL.EXTERNAL.FILES'),
      Imagens: t('PORTAL.EXTERNAL.IMAGES'),
      Compartilhar: t('PORTAL.BUTTON.SHARE'),
      'Exames externos': t('PORTAL.BUTTON.INCLUDE_EXAMS'),
    };

    return labels[opcao] || opcao || '';
  };

  getConfiguredLabel = (label, key, defaultLabels = []) => {
    const normalizedLabel = (label || '').trim().toLowerCase();
    const isDefaultLabel = defaultLabels.some(
      defaultLabel => defaultLabel.toLowerCase() === normalizedLabel
    );

    return label && !isDefaultLabel ? label : this.props.t(key);
  };

  //#endregion

  //COMPONENT_DID_MOUNT
  //#region COMPONENT_DID_MOUNT
  componentDidMount() {
    const historicoAceiteLGPD = new HistoricoAceiteLGPD();
    historicoAceiteLGPD.ChecarAceiteLGPD();
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    if (!auth) {
      window.location = '#/';
      return;
    }

    const appLang = localStorage.getItem('appLang');
    if (appLang && i18n.language !== appLang) {
      i18n.changeLanguage(appLang);
    }

    const isAcessoCompartilhado = !!auth.TokenPortal;
    this.setState({
      isMedico: ServiceLogin.isMedico(),
      isExecutante: ServiceLogin.isExecutante(),
      isConvenio: ServiceLogin.isConvenio(),
      UsuarioId: ServiceLogin.getUserId(),
      UsuarioNome: ServiceLogin.getUserName(),
      isAcessoCompartilhado,
      pesquisarExamesExternos: isAcessoCompartilhado ? false : this.state.pesquisarExamesExternos,
      mostrarFiltro: isAcessoCompartilhado ? false : this.state.mostrarFiltro,
      panelImageMaximizeOn: false,
    });

    this.setState({
      isExecutante: ServiceLogin.isExecutante(),
    });

    this._getUrl().then(url => this.setState({ caminhoServico: url }));

    this.atualizarZoomPDF();
    window.addEventListener('resize', this.atualizarZoomPDF);

    window.addEventListener('resize', this.handleResize);

    this.getConfig();

    //Filtrar pela Data Atual
    let ano = new Date().getFullYear();
    let mes = new Date().getMonth() + 1;
    let dia = new Date().getDate();

    const dataAtual = moment(
      `${ano.toString()}-${mes.toString()}-${dia.toString()}`,
      'YYYY/MM/DD'
    ).format();
    let dataInicial = dataAtual;

    if (!ServiceLogin.isMedico()) {
      dataInicial = moment(`${'0'}-${mes.toString()}-${dia.toString()}`, 'YYYY/MM/DD').format();

      ServiceLogin.isConvenio()
        ? (pedidoFiltro.ConvenioId = ServiceLogin.getConvenioId())
        : (pedidoFiltro.PacienteId = ServiceLogin.getUserId());
    }

    pedidoFiltro.DataInicial = dataInicial;
    pedidoFiltro.DataFinal = dataAtual;

    //if (window.globalVars.acessoMedicoSolicitante === true) {
    if (sessionStorage.getItem('perfil') === 'Solicitante') {
      pedidoFiltro.MedicoSolicitanteFiltro = { Id: ServiceLogin.getMedicoSolicitanteId() };
    }

    if (sessionStorage.getItem('perfil') === 'Executante') {
      pedidoFiltro.Unidades = ServiceLogin.getUnidadesMedicoExecutante();
    }

    if (auth.MedicoExecutanteFixo) {
      pedidoFiltro.Unidades = ServiceLogin.getUnidadesMedicoExecutante();
    }

    // setTimeout(() => {
    //     this.DesabilitarBtnImagem(this.state.pedidos[0], false)
    //         .then((result) => {
    //             this.setState({ btnImageDisable: result, isLoading: false });
    //         })
    //         .catch((error) => {
    //             console.error("Erro ao desabilitar botão:", error);
    //             this.setState({ btnImageDisable: true, isLoading: false }); // Default caso ocorra erro
    //         });
    // }, 1000);

    if (!sessionStorage.getItem('refreshOnce')) {
      try {
        sessionStorage.setItem('refreshOnce', 'true');
      } catch {}
      setTimeout(() => window.location.reload(), 200);
    } else {
      sessionStorage.removeItem('refreshOnce');
    }

    setTimeout(() => {
      this.alterarLayout();
    }, 500);
  }
  //#endregion

  getConfig() {
    try {
      this.serviceConfig = new ServiceConfig();

      this.serviceConfig
        .GetConfig()
        .then(res => {
          console.log('Resposta bruta:', res);

          let arr = [];

          if (Array.isArray(res.data)) {
            arr = res.data;
          } else if (Array.isArray(res)) {
            arr = res;
          } else if (typeof res.data === 'string') {
            arr = JSON.parse(res.data);
          } else if (typeof res === 'string') {
            arr = JSON.parse(res);
          } else {
            console.error('Formato inesperado de resposta:', res);
            return;
          }

          // Grava a credencial do serviço de imagens antes de qualquer request ao PACS
          // (aplicarFiltroInicial() roda no callback do setState abaixo)
          persistViewerAccessKey(arr);

          const config = {};
          arr.forEach(item => {
            config[item.Key] = {
              id: item.Id,
              value: item.Value,
            };
          });

          console.log('Config mapeada:', config);

          const diasPesquisaInicialAoLogarMedico =
            parseInt(config['DIAS_PESQUISA_INICIAL_AO_LOGAR_MEDICO']?.value, 10) || 0;
          const isPerfilMedico = ServiceLogin.isMedico() && !ServiceLogin.isConvenio();

          let periodoSelecionado = this.state.periodoSelecionado;
          let dataInicial = this.state.dataInicial;
          let dataFinal = this.state.dataFinal;

          if (isPerfilMedico && diasPesquisaInicialAoLogarMedico > 0) {
            const hoje = new Date();
            const inicio = new Date();
            inicio.setDate(hoje.getDate() - diasPesquisaInicialAoLogarMedico);
            periodoSelecionado = 'ultimosN';
            dataInicial = inicio;
            dataFinal = hoje;
          }

          this.setState(
            {
              configDB: config,
              diasPesquisaInicialAoLogarMedico,
              periodoSelecionado,
              dataInicial,
              dataFinal,

              // Labels
              labelBotaoViewer: config['LABEL_BOTAO_VIEWER_PORTAL']?.value || '',
              labelBotaoGaleria: config['LABEL_BOTAO_GALERIA_PORTAL']?.value || '',
              labelBotaoBaixarDicom: config['LABEL_BOTAO_BAIXAR_DICOM_PORTAL']?.value || '',
              labelBotaoLaudo: config['LABEL_BOTAO_LAUDO_PORTAL']?.value || '',
              labelBotaoImprimirLaudo: config['LABEL_BOTAO_IMPRIMIR_LAUDO_PORTAL']?.value || '',
              labelBotaoBaixarLaudoPdf: config['LABEL_BOTAO_BAIXAR_LAUDO_PDF_PORTAL']?.value || '',
              labelBotaoAnexos: config['LABEL_BOTAO_VISUALIZAR_ANEXOS_PORTAL']?.value || '',
              labelBotaoParecer: config['LABEL_BOTAO_VISUALIZAR_PARECER_PORTAL']?.value || '',
              labelInfoAcNumber: config['LABEL_INFO_ACENUMBER_PORTAL']?.value || '',
              labelInfoUnidade: config['LABEL_INFO_UNIDADE_PORTAL']?.value || '',
              labelInfoData: config['LABEL_INFO_DATA_PORTAL']?.value || '',
              labelInfoMedSolicitante: config['LABEL_INFO_MEDICO_SOLICITANTE_PORTAL']?.value || '',
              labelInfoMedExecutante: config['LABEL_INFO_MEDICO_EXECUTANTE_PORTAL']?.value || '',
              labelInfoMedRevisor: config['LABEL_INFO_MEDICO_REVISOR_PORTAL']?.value || '',
              labelBotaoCompartilhar: config['LABEL_BOTAO_COMPARTILHAR_PORTAL']?.value || '',
              lblbtnDownloadVisualizador: config['LABEL_BOTAO_BAIXAR_VISUALIZADOR']?.value || '',
              lblbtnDownloadDicomZip: config['LABEL_BOTAO_BAIXAR_ZIP']?.value || '',

              // Status labels
              labelStatusProcessamentoPaciente:
                config['LABEL_STATUS_PROCESSAMENTO_PACIENTE_PORTAL']?.value || '',
              labelStatusAguardandoPaciente:
                config['LABEL_STATUS_AGUARDANDO_PACIENTE_PORTAL']?.value || '',
              labelStatusLiberadoPaciente:
                config['LABEL_STATUS_LIBERADO_PACIENTE_PORTAL']?.value || '',
              labelStatusProcessamentoMedico:
                config['LABEL_STATUS_PROCESSAMENTO_MEDICO_PORTAL']?.value || '',
              labelStatusAguardandoMedico:
                config['LABEL_STATUS_AGUARDANDO_MEDICO_PORTAL']?.value || '',
              labelStatusLiberadoMedico: config['LABEL_STATUS_LIBERADO_MEDICO_PORTAL']?.value || '',

              // Paciente - botoes
              botaoViewerAtivoPaciente:
                config['BOTAO_VIEWER_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoGaleriaAtivoPaciente:
                config['BOTAO_GALERIA_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoBaixarImagensAtivoPaciente:
                config['BOTAO_BAIXAR_IMAGENS_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoLaudoAtivoPaciente:
                config['BOTAO_LAUDO_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoImprimirLaudoAtivoPaciente:
                config['BOTAO_IMPRIMIR_LAUDO_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoCompartilharAtivoPaciente:
                config['BOTAO_COMPARTILHAR_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoAnexosAtivoPaciente:
                config['BOTAO_ANEXOS_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              botaoIncluirExamesAtivoPaciente:
                config['BOTAO_INCLUIR_EXAMES_ATIVO_PACIENTE_PORTAL']?.value === 'true',

              acaoBaixarImagens_visualizador_Paciente:
                config['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_PACIENTE']?.value === 'true',
              acaoBaixarImagens_dicomZip_Paciente:
                config['ACAO_BAIXAR_IMAGENS_ZIP_PACIENTE']?.value === 'true',

              // Paciente - infos
              infoAcNumberAtivoPaciente:
                config['INFO_ACNUMBER_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              infoProntuarioAtivoPaciente:
                config['INFO_PRONTUARIO_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              infoDataAtivoPaciente: config['INFO_DATA_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              infoUnidadeAtivoPaciente:
                config['INFO_UNIDADE_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              infoMedSolicitanteAtivoPaciente:
                config['INFO_MED_SOLICITANTE_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              infoMedExecutanteAtivoPaciente:
                config['INFO_MED_EXECUTANTE_ATIVO_PACIENTE_PORTAL']?.value === 'true',
              infoMedRevisorAtivoPaciente:
                config['INFO_MED_REVISOR_ATIVO_PACIENTE_PORTAL']?.value === 'true',

              // Paciente - acoes
              acaoPrincipalBotaoImagensPaciente:
                config['ACAO_PRINCIPAL_BOTAO_IMAGENS_PACIENTE_PORTAL']?.value || '',
              acaoPrincipalThumbnailImagensPaciente:
                config['ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_PACIENTE_PORTAL']?.value || '',
              statusAtivoPaciente: config['STATUS_ATIVO_PACIENTE_PORTAL']?.value === 'true',

              // Medico - botoes
              botaoViewerAtivoMedico: config['BOTAO_VIEWER_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoGaleriaAtivoMedico:
                config['BOTAO_GALERIA_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoBaixarImagensAtivoMedico:
                config['BOTAO_BAIXAR_IMAGENS_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoLaudoAtivoMedico: config['BOTAO_LAUDO_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoImprimirLaudoAtivoMedico:
                config['BOTAO_IMPRIMIR_LAUDO_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoCompartilharAtivoMedico:
                config['BOTAO_COMPARTILHAR_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoAnexosAtivoMedico: config['BOTAO_ANEXOS_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoParecerAtivoMedico:
                config['BOTAO_PARECER_ATIVO_MEDICO_PORTAL']?.value === 'true',
              botaoIncluirExamesAtivoMedico:
                config['BOTAO_INCLUIR_EXAMES_ATIVO_MEDICO_PORTAL']?.value === 'true',

              acaoBaixarImagens_visualizador_Medico:
                config['ACAO_BAIXAR_IMAGENS_VISUALIZADOR_MEDICO']?.value === 'true',
              acaoBaixarImagens_dicomZip_Medico:
                config['ACAO_BAIXAR_IMAGENS_ZIP_MEDICO']?.value === 'true',

              // Medico - infos
              infoAcNumberAtivoMedico:
                config['INFO_ACNUMBER_ATIVO_MEDICO_PORTAL']?.value === 'true',
              infoProntuarioAtivoMedico:
                config['INFO_PRONTUARIO_ATIVO_MEDICO_PORTAL']?.value === 'true',
              infoDataAtivoMedico: config['INFO_DATA_ATIVO_MEDICO_PORTAL']?.value === 'true',
              infoUnidadeAtivoMedico: config['INFO_UNIDADE_ATIVO_MEDICO_PORTAL']?.value === 'true',
              infoMedSolicitanteAtivoMedico:
                config['INFO_MED_SOLICITANTE_ATIVO_MEDICO_PORTAL']?.value === 'true',
              infoMedExecutanteAtivoMedico:
                config['INFO_MED_EXECUTANTE_ATIVO_MEDICO_PORTAL']?.value === 'true',
              infoMedRevisorAtivoMedico:
                config['INFO_MED_REVISOR_ATIVO_MEDICO_PORTAL']?.value === 'true',

              // Medico - acoes
              acaoPrincipalBotaoImagensMedico:
                config['ACAO_PRINCIPAL_BOTAO_IMAGENS_MEDICO_PORTAL']?.value || '',
              acaoPrincipalThumbnailImagensMedico:
                config['ACAO_PRINCIPAL_THUMBNAIL_IMAGENS_MEDICO_PORTAL']?.value || '',
              statusAtivoMedico: config['STATUS_ATIVO_MEDICO_PORTAL']?.value === 'true',
              habilitarEnvioDicomExamesExternos:
                config['HABILITAR_ENVIO_DICOM_EXAMES_EXTERNOS']?.value === 'true',
              pesquisarExamesExternos:
                ServiceLogin.isMedico() || ServiceLogin.isExecutante()
                  ? config['PESQUISA_EXAMES_EXTERNOS_ATIVO_MEDICO']?.value === 'true'
                  : this.state.pesquisarExamesExternos,

              // Geral
              tempoInatividade: config['TEMPO_INATIVIDADE_PORTAL']?.value || '',
              servicoImagemPortal: config['SERVICO_IMAGEM']?.value || '',
              pesquisa_Inicial_Exames_Paciente:
                config['PESQUISA_INICIAL_EXAMES_PACIENTE']?.value || 'Padrao',
              usarRangeDataPaciente:
                (config['PESQUISA_INICIAL_EXAMES_PACIENTE']?.value || 'Padrao') === 'Filtro',

              exibir_apenas_pedidos_revisados_portal:
                config['EXIBIR_APENAS_PEDIDOS_REVISADOS_PORTAL']?.value === 'true',
            },
            () => {
              this.aplicarFiltroInicial();
            }
          );
        })
        .catch(err => console.error('Erro no GetConfig:', err));
    } catch (err) {
      console.error('Erro catch getConfig:', err);
    }
  }

  aplicarFiltroInicial = () => {
    const { pesquisa_Inicial_Exames_Paciente, dataInicial, dataFinal, isMedico } = this.state;

    const filtroBase = {
      modalidades: [],
      paciente: '',
      acNumber: '',
      prontuario: '',
      dataInicial: '',
      dataFinal: '',
    };

    if (pesquisa_Inicial_Exames_Paciente === 'Filtro' || isMedico) {
      filtroBase.dataInicial = dataInicial;
      filtroBase.dataFinal = dataFinal;
    }

    this.onExecuteFiltro(filtroBase);
  };

  //CONSTS/VARIÁVEIS DE CLASSE
  //#region CONSTS/VARIÁVEIS DE CLASSE
  cameraInputRef = null;
  lastPedidosRequestId = 0;
  //#endregion

  //METHODS
  //#region METHODS

  mobilecheck() {
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  _getUrl() {
    return axios
      .get('config.json')
      .then(res => res.data.servico)
      .then(url => {
        if (url[url.length - 1] === '/') return url;
        return url + '/';
      });
  }

  atualizarZoomPDF = () => {
    const { urlLaudoPdf } = this.state;

    // Protege contra undefined
    if (!urlLaudoPdf || typeof urlLaudoPdf !== 'string') return;

    const larguraTela = window.innerWidth;

    let zoom = 100;
    if (larguraTela <= 480) zoom = 50;
    else if (larguraTela <= 768) zoom = 60;
    else if (larguraTela <= 1024) zoom = 100;
    else zoom = 100;

    const baseUrl = urlLaudoPdf.split('#')[0];
    const novaUrl = `${baseUrl}#zoom=${zoom}`;

    this.setState({ urlLaudoPdf: novaUrl });
  };

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  retDataFormatada(value) {
    return value;
  }

  retLegendaPrioridade(prioridade) {
    if (prioridade === 0) return this.props.t('PORTAL.PRIORITY.NONE');
    if (prioridade === 1) return this.props.t('PORTAL.PRIORITY.LOW');
    if (prioridade === 2) return this.props.t('PORTAL.PRIORITY.MEDIUM');
    if (prioridade === 3) return this.props.t('PORTAL.PRIORITY.HIGH');
  }

  sucessoSalvarParecer(response) {
    alert(this.props.t('PORTAL.MESSAGE.MEDICAL_OPINION_SAVED'));
    this.limparFormParecer();
  }

  limparFormParecer() {
    this.setState({
      parecerId: 0,
      parecerTexto: '',
      parecerPrioridade: 0,
      visibleDialogComentario: false,
    });
  }

  RetPerfil() {
    if (ServiceLogin.isConvenio()) {
      sessionStorage.setItem('perfil', 'Convenio');
      return 'Convênio';
    }
    if (this.state.isExecutante) {
      sessionStorage.setItem('perfil', 'Executante');
      return 'Médico Executante';
    }
    if (this.state.isMedico) {
      sessionStorage.setItem('perfil', 'Solicitante');
      return 'Médico Solicitante';
    } else {
      return 'Paciente';
    }
  }

  alterarLayout = () => {
    let perfil = document.getElementById('perfil').innerText;
    if (perfil !== 'Médico Executante') {
      var head = document.getElementsByTagName('HEAD')[0];
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      let layout = 'layout/temaPaciente.css';
      if (perfil == 'Médico Solicitante') {
        layout = 'layout/temaMedico.css';
      }
      link.href = layout;
      head.appendChild(link);
    }
  };

  AdicionarHistoricoAcoes(operacao, pedidoId, tipo) {
    if (tipo === 'interno') {
      let usuarioId =
        !this.state.isMedico && !this.state.isExecutante ? null : this.state.UsuarioId;
      let url = `Api/Pedido/PostAdicionarHistorico/?operacao=${operacao}&usuarioId=${usuarioId}&pedidoId=${pedidoId}&acaoConvenio=${this.state.isConvenio}`;
      return ServiceApi.post(url);
    }
  }

  IsNullOrEmpty(value) {
    return value === null || value === '';
  }

  DesabilitarBtnLaudo(pedido) {
    if (pedido.Tipo === 'externo') {
      return false;
    }

    if (this.state.isMedico & ServiceLogin.getNaoPodeVisualizarPedidoSemServico())
      return !pedido.PossuiServico;

    if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataImpresso === null) return true;

    if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataEntregue === null) return true;

    if (pedido.ContemAnexoDiagnostico && pedido.DataRevisado) return false;

    if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataLaudado && pedido.DataRevisado)
      return pedido.DataEntregue === null || pedido.DataEntregue === '';

    if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataLaudado && pedido.DataRevisado)
      return pedido.DataImpresso === null || pedido.DataImpresso === '';

    return pedido.DataRevisado === null || pedido.DataRevisado === '';
  }

  DesabilitarBtnLaudoSemServico(pedido) {
    return ServiceLogin.getNaoPodeVisualizarPedidoSemServico() ? !pedido.PossuiServico : false;
  }

  DesabilitarBtnImagemSemServico(pedido) {
    return ServiceLogin.getNaoPodeVisualizarImagemPedidoSemServico()
      ? !pedido.PossuiServico
      : false;
  }

  DesabilitarBtnAnexo(pedido) {
    try {
      return pedido.Anexos.Count === 0;
    } catch (ex) {}
    return true;
  }

  DesabilitarBtnImagem(pedido, btnImagemDisabledSemServico) {
    return new Promise(resolve => {
      if (pedido.Tipo === 'externo') {
        return false;
      }

      if (this.state.isMedico && btnImagemDisabledSemServico) {
        resolve(btnImagemDisabledSemServico);
      } else {
        const possuiJob = listarJob()
          .then(res => {
            return res.length > 0;
          })
          .catch(() => false);

        if (!possuiJob) {
          if (pedido.StatusImagem === 2) {
            resolve(false);
            return;
          }

          if (this.IsNullOrEmpty(pedido.StudyUid)) {
            resolve(true);
            return;
          }
        }

        this.galeriaServices
          .getValuesServiceSerie(pedido.Unidade.ServicoImagemPortal, pedido.StudyUid)
          .then(response => {
            if (response.length === 0) {
              return this.delay(500).then(() => resolve(true));
            }
            resolve(false);
          })
          .catch(() => resolve(true));
      }
    });
  }

  msgLaudoNaoLiberado(pedido, btnLaudoDisabledSemServico, btnImageDisabledSemServico) {
    if (this.state.isMedico) {
      if (btnLaudoDisabledSemServico || btnImageDisabledSemServico)
        return (
          <div
            style={{
              fontWeight: 'bold',
              textAlign: 'right',
              marginTop: '10px',
              marginRight: '10px',
              color: 'red',
            }}>
            {this.props.t('PORTAL.CARD.ORDER_WITHOUT_SERVICE')}
          </div>
        );
    }
    const msgAlert = (
      <div
        style={{
          fontWeight: 'bold',
          textAlign: 'right',
          marginTop: '10px',
          marginRight: '10px',
          color: 'red',
        }}>
        {this.props.t('PORTAL.CARD.REPORT_NOT_RELEASED')}
      </div>
    );
    if (pedido.Unidade.ImprimirLaudoEntreguePortal && pedido.DataEntregue === null) return msgAlert;
    if (pedido.Unidade.ImprimirLaudoImpressoPortal && pedido.DataImpresso === null) return msgAlert;
    if (pedido.DataRevisado === null) return msgAlert;
    return '';
  }

  positionScroll() {
    window.scroll(0, 0);
    if (this.state.onPositionScroll) {
      try {
        const topPos = document.getElementById('gridListaPedidos').offsetTop - 50;
        window.scroll(0, topPos);
      } catch (error) {}
    }
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  fetchImage = async url => {
    let imageUrl = null;
    const authHeader = getViewerAuthHeader();
    const response = await fetch(url, {
      headers: authHeader ? { Authorization: authHeader } : {},
    });
    const blob = await response.blob();
    if (blob.size > 0) {
      this.setState({ imagemCarregada: true });
      imageUrl = URL.createObjectURL(blob);
    }

    return imageUrl;
  };

  buscarImagensPreviewParaPedidos = async pedidos => {
    const novosPedidos = await Promise.all(
      pedidos.map(async pedido => {
        try {
          const headers = ServiceApi._getHeaders().headers;

          // 1. Verifica se existe job para o pedido
          const jobs = await listarJob(pedido.AcNumber, pedido.Unidade.Id);
          if (Array.isArray(jobs) && jobs.length > 0) {
            // 2. Busca as imagens do primeiro job
            const imagensJob = await BuscarImagensLista(jobs[0].Id, pedido.Unidade.Id);
            if (Array.isArray(imagensJob) && imagensJob.length > 0) {
              // 3. Usa a primeira imagem do job como preview
              return {
                ...pedido,
                imagemPreviewUrl: `data:image/jpeg;base64,${imagensJob[0].ImageBase64}`,
                possuiJob: true,
              };
            }
          }

          // Se não tem job, segue fluxo normal
          if (headers.user !== null) {
            const base = pedido.Unidade?.ServicoImagemPortal ?? this.state.servicoImagemPortal;
            const studyUid = pedido.StudyUid;
            const cleanedBase = base.endsWith('/studies') ? base : `${base}/studies`;
            const infoUrl = `${cleanedBase}/${studyUid}/getstudyimagens`;

            const response = await axios.get(infoUrl, { headers });
            const imagens = response.data?.instanceImage;

            if (Array.isArray(imagens) && imagens.length > 0) {
              const primeiraSerie = imagens[0];
              const instancias = primeiraSerie.instances;

              if (!primeiraSerie.serie || !Array.isArray(instancias) || instancias.length === 0) {
                return { ...pedido, imagemPreviewUrl: null, possuiJob: false };
              }

              const meio = Math.floor(instancias.length / 2);
              const instanceUID = instancias[meio];

              const urlPreview = `${cleanedBase}/${studyUid}/series/${primeiraSerie.serie}/instances/${instanceUID}/frames/0/rendered`;
              const imageUrl = await this.fetchImage(urlPreview);
              return { ...pedido, imagemPreviewUrl: imageUrl, possuiJob: false };
            } else {
              return { ...pedido, imagemPreviewUrl: null, possuiJob: false };
            }
          }
        } catch (e) {
          return { ...pedido, imagemPreviewUrl: null, possuiJob: false };
        }
      })
    );

    return novosPedidos;
  };

  getClasseVisualizador() {
    const opcao = this.state.modalOpcaoSelecionada;

    switch (opcao) {
      case 'Laudo':
      case 'Galeria':
        return 'full';
      case 'Compartilhar':
        return 'compartilhar';
      case 'Exames externos':
        return 'examesExternos';
      case 'Anexos':
        return 'anexos';
      case 'Arquivos':
        return 'arquivos';
      case 'Parecer':
        return 'parecer';
      default:
        return 'full';
    }
  }

  buscarProcedimentos = async e => {
    const termo = e.query?.trim();
    const modalidadeId = 0;

    const url = `${this.state.caminhoServico}/Api/Portal/PostListarProcedimentos?procedimento=${encodeURIComponent(termo)}&modalidadeId=${encodeURIComponent(modalidadeId)}&medicoId=0`;

    try {
      const authHeaders = ServiceApi._getHeaders().headers;

      const headers = new Headers();
      headers.append('user', authHeaders.user);
      headers.append('Cnonce', authHeaders.Cnonce);
      headers.append('Token', authHeaders.Token);
      headers.append('TokenPortal', authHeaders.TokenPortal);
      headers.append('isPacientePortal', authHeaders.isPacientePortal);
      headers.append('isConvenioPortal', authHeaders.isConvenioPortal);

      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Erro ${response.status}: ${text}`);
      }

      const procedimentos = await response.json();
      this.setState({ procedimentosSugeridos: procedimentos });
    } catch (error) {
      console.error('Erro ao buscar procedimentos:', error.message);
      this.setState({ procedimentosSugeridos: [] });
    }
  };

  adicionarArquivos = novosArquivos => {
    const arquivosAtuais = this.state.arquivosSelecionados;

    const todos = [...arquivosAtuais, ...novosArquivos].filter(
      (file, index, self) =>
        index === self.findIndex(f => f.name === file.name && f.size === file.size)
    );

    this.setState({ arquivosSelecionados: todos });
  };

  //#endregion

  //HANDLES
  //#region HANDLES

  mapSortValue = sortValue => {
    switch (sortValue) {
      case 'recentes':
        return 'DataEstudo Desc';
      case 'antigos':
        return 'DataEstudo Asc';
      case 'procedimento':
        return 'Procedimento';
      default:
        return sortValue;
    }
  };

  deveUsarRangeData = () => {
    const isPaciente = !this.state.isMedico && !this.state.isExecutante && !this.state.isConvenio;
    return !isPaciente || this.state.usarRangeDataPaciente;
  };

  isPerfilMedico = () => {
    return this.state.isMedico || this.state.isExecutante;
  };

  listarPedidosPorPerfil = () => {
    return this.isPerfilMedico()
      ? this.pedidoservice.listarPortalExamesPaged(pedidoFiltro)
      : this.pedidoservice.listarPortalExamesPagedAdvanced(pedidoFiltro);
  };

  onExecuteFiltro(filtro) {
    // Verificação: data inicial > data final
    if (new Date(filtro.dataInicial) > new Date(filtro.dataFinal)) {
      this.setState({
        dataInicialInvalida: true,
        dataFinalInvalida: true,
        modalErroVisivel: true,
        mensagemErro: this.props.t('PORTAL.FILTER.INITIAL_DATE_AFTER_END'),
        isLoading: false,
      });
      return;
    }

    if (new Date(filtro.dataFinal) < new Date(filtro.dataInicial)) {
      this.setState({
        dataFinalInvalida: true,
        modalErroVisivel: true,
        mensagemErro: this.props.t('PORTAL.FILTER.END_DATE_BEFORE_INITIAL'),
        isLoading: false,
      });
      return;
    }

    // Se passou nas validações, limpa os erros
    this.setState({
      dataInicialInvalida: false,
      dataFinalInvalida: false,
      isLoading: true,
    });

    pedidoFiltro.Modalidades = filtro.modalidades;
    pedidoFiltro.PacienteNome = filtro.paciente;
    pedidoFiltro.AcNumber = filtro.acNumber;
    pedidoFiltro.Prontuario = filtro.prontuario;
    pedidoFiltro.DataInicial = filtro.dataInicial;
    pedidoFiltro.DataFinal = filtro.dataFinal;
    pedidoFiltro.PageIndex = 0;
    pedidoFiltro.PageCount = this.state.rows;
    pedidoFiltro.Procedimento = filtro.procedimento;
    pedidoFiltro.ProcedimentoId = filtro.selectedProcedimentoId;
    pedidoFiltro.PesquisarPedidosExternos = this.state.isAcessoCompartilhado
      ? false
      : this.state.pesquisarExamesExternos;
    pedidoFiltro.ProcedimentoNome = this.state.nomeExame;
    pedidoFiltro.Sort = this.mapSortValue(this.state.sort);

    if (this.state.exibir_apenas_pedidos_revisados_portal) {
      pedidoFiltro.Revisado = true;
    }

    const requestId = ++this.lastPedidosRequestId;
    const dados = this.listarPedidosPorPerfil();

    dados
      .then(data => {
        if (requestId !== this.lastPedidosRequestId) return;

        let pedidos = data.PedidosPortal || [];

        // marca STL e anexos (não depende de imagens) — roda imediatamente
        pedidos.forEach(p => {
          const anexos = p.Anexos?.Anexos || [];
          p.temStl = anexos.some(anexo => anexo?.Nome?.toLowerCase().endsWith('.stl'));
        });

        const internosMarcados = pedidos.filter(p => p.Tipo === 'interno');
        const externosMarcados = pedidos.filter(p => p.Tipo === 'externo');

        const totalInternos = Number(data.CountTotal || 0);
        const totalExternos = Number(data.CountExternos || 0);

        const totalCombinado = totalInternos + totalExternos;

        const pedidosCombinados = pedidos;

        // Render imediato da lista, sem esperar as imagens
        this.setState({
          pedidos: internosMarcados,
          pedidosExternos: externosMarcados,
          pedidosCombinados,
          totalPedidos: totalCombinado,
          Total: totalCombinado,
          TotalPedidosInternos: totalInternos,
          TotalPedidosExternos: totalExternos,
          first: 0,
          rows: this.state.rows,
          panelImageVisible: false,
          panelLaudoVisible: false,
          onPositionScroll: false,
          isLoading: false,
        });

        if (totalCombinado > 0) {
          this.positionScroll();
        }

        if (totalCombinado === 0 && !this.state.mostrarFiltro) {
          setTimeout(() => this.setState({ mostrarFiltro: true }), 3000);
        }

        // Busca de imagens em segundo plano — não bloqueia a renderização
        this.buscarImagensPreviewParaPedidos(pedidos)
          .then(pedidosComImagens => {
            if (requestId !== this.lastPedidosRequestId) return;
            if (!Array.isArray(pedidosComImagens)) return;

            const porId = new Map(pedidosComImagens.map(p => [p.Id, p]));
            const mergeImagem = p => porId.get(p.Id) || p;

            this.setState(prevState => ({
              pedidosCombinados: prevState.pedidosCombinados.map(mergeImagem),
              pedidos: prevState.pedidos.map(mergeImagem),
              pedidosExternos: prevState.pedidosExternos.map(mergeImagem),
            }));
          })
          .catch(err => console.warn('Erro ao buscar imagens preview:', err));
      })

      .catch(error => {
        if (requestId !== this.lastPedidosRequestId) return;
        console.error('Erro ao executar filtro:', error);
        this.setState({ isLoading: false });
      });
  }

  onPageChange = event => {
    const pageIndex = Math.floor(event.first / event.rows);
    const sortValue = event.forceSort || this.mapSortValue(this.state.sort);

    pedidoFiltro.PageIndex = pageIndex;
    pedidoFiltro.PageCount = event.rows;
    pedidoFiltro.Sort = sortValue;

    this.setState({ isLoading: true });

    const requestId = ++this.lastPedidosRequestId;

    this.listarPedidosPorPerfil()
      .then(data => {
        if (requestId !== this.lastPedidosRequestId) return;

        let pedidos = data.PedidosPortal || [];

        pedidos.forEach(p => {
          const anexos = p.Anexos?.Anexos || [];
          p.temStl = anexos.some(anexo => anexo?.Nome?.toLowerCase().endsWith('.stl'));
        });

        const pedidosCombinados = pedidos;
        const totalInternos = Number(data.CountTotal || 0);
        const totalExternos = Number(data.CountExternos || 0);
        const totalCombinado = totalInternos + totalExternos;

        this.setState({
          pedidos: pedidosCombinados.filter(p => p.Tipo === 'interno'),
          pedidosExternos: pedidosCombinados.filter(p => p.Tipo === 'externo'),
          pedidosCombinados,
          totalPedidos: totalCombinado,
          Total: totalCombinado,
          TotalPedidosInternos: totalInternos,
          TotalPedidosExternos: totalExternos,
          first: event.first,
          rows: event.rows,
          panelImageVisible: false,
          panelImageJpegVisible: false,
          panelLaudoVisible: false,
          panelVisible: false,
          isLoading: false,
        });

        this.buscarImagensPreviewParaPedidos(pedidos)
          .then(pedidosComImagens => {
            if (requestId !== this.lastPedidosRequestId) return;
            if (!Array.isArray(pedidosComImagens)) return;

            const porId = new Map(pedidosComImagens.map(p => [p.Id, p]));
            const mergeImagem = p => porId.get(p.Id) || p;

            this.setState(prevState => ({
              pedidosCombinados: prevState.pedidosCombinados.map(mergeImagem),
              pedidos: prevState.pedidos.map(mergeImagem),
              pedidosExternos: prevState.pedidosExternos.map(mergeImagem),
            }));
          })
          .catch(err => console.warn('Erro ao buscar imagens preview:', err));
      })
      .catch(error => {
        if (requestId !== this.lastPedidosRequestId) return;
        console.error('Erro ao paginar pedidos:', error);
        this.setState({ isLoading: false });
      });
  };

  viewFullScreen(panel) {
    let el = document.getElementById(panel);
    let elContent = el.getElementsByClassName('p-panel-content')[0];
    this.state.isFullScreen = !this.state.isFullScreen;
    if (this.state.isFullScreen === true) {
      el.setAttribute(
        'style',
        'visibility: visible;position: fixed;width: 100%;top: 0;left: 0;bottom: 0;background: white;z-index: 99999;padding:0'
      );
      //elContent.setAttribute("style", "padding:0");
      elContent.firstElementChild.setAttribute(
        'style',
        'height:' + (window.innerHeight - 50) + 'px'
      );
    } else {
      el.setAttribute('style', 'visibility: visible;');
      elContent.removeAttribute('style');
      elContent.firstElementChild.setAttribute('style', 'height:75vh');
    }
  }

  closeModalFullScreen(panel) {
    let el = document.getElementById(panel);
    el.removeAttribute('style');
    this.setState({ panelVisible: false, isFullScreen: false });
  }

  onSortChange(event) {
    if (event === 'clear') {
      this.setState({ sortKey: 'Ordenar por' });
      return;
    }

    const nextSort = event?.value;
    const mappedSort = this.mapSortValue(nextSort);

    this.setState(
      {
        sortKey: nextSort,
        sort: nextSort,
        first: 0,
        isLoading: true,
      },
      () => {
        pedidoFiltro.Sort = mappedSort;
        pedidoFiltro.PageIndex = 0;
        this.onPageChange({ first: 0, rows: this.state.rows, forceSort: mappedSort });
      }
    );
  }

  onHideGaleria() {
    this.setState({ panelImageJpegVisible: false });
  }

  onChangeDataViewLayoutOptions(value) {
    this.setState({ layout: value });
  }

  panelImageJpegMaximize() {
    this.setState({ isFull: !this.state.isFull });
  }

  openDialogParecer(pedido) {
    this.limparFormParecer();
    let _pedidoId = pedido.Id;
    this.setState({ visibleDialogComentario: true, selectedPedido: pedido });
    let medicoService = new MedicoService();
    medicoService
      .GetParecerMedico(_pedidoId)
      .then(data => {
        console.log(data);
        let _listaParecer = [];

        data.Comentarios.forEach(el => {
          let dados = {
            DataCadastro: moment(el.DataCadastro).format('DD/MM/YYYY'),
            Prioridade: this.retLegendaPrioridade(el.Prioridade),
            Texto: el.Texto,
          };
          _listaParecer.push(dados);
        });

        this.setState({
          listaParecer: _listaParecer,
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  handleClickSelecionarPastaDicom() {
    if (this.inputPastaRef.current) {
      this.inputPastaRef.current.click();
    }
  }

  handleSalvarParecer() {
    let parecerDTO = {
      Id: 0,
      PedidoId: this.state.selectedPedido.Id,
      UsuarioId: this.state.UsuarioId,
      UsuarioNome: this.state.UsuarioNome,
      Texto: this.state.parecerTexto,
      Prioridade: this.state.parecerPrioridade,
      ParecerMedico: true,
    };
    let medicoService = new MedicoService();
    medicoService
      .PostAdicionarParecer(parecerDTO)
      .then(response => {
        this.sucessoSalvarParecer(response);
        this.AdicionarHistoricoAcoes(
          33,
          this.state.selectedPedido.Id,
          this.state.selectedPedido.Tipo
        );
      })
      .catch(error => {
        console.log(error);
      });
  }

  openDialogArquivos = async pedido => {
    this.setState({
      arquivosDialogOpen: true,
      pedidoSelecionadoArquivos: pedido,
    });
  };

  closeDialogArquivos = () => {
    this.setState({
      arquivosDialogOpen: false,
      pedidoSelecionadoArquivos: null,
      anexosDoPedido: [],
    });
  };

  visualizarListaAnexos(pedido) {
    this.state.listaAnexos = null;

    let _listaAnexos = [];

    const isExecutante = this.state.isExecutante;

    // Se for médico executante, mostra todos os anexos
    if (isExecutante) {
      _listaAnexos = pedido.Anexos.Anexos;
    } else {
      // Senão, mostra só os arquivos STL
      _listaAnexos = pedido.Anexos.Anexos.filter(
        anexo =>
          anexo.TipoAnexo?.toLowerCase() === 'stl' || anexo.Nome?.toLowerCase().endsWith('.stl')
      );
    }

    this.setState({
      listaAnexos: _listaAnexos,
      modalAnexo: true,
      selectedPedido: pedido,
    });
  }

  openModalCompartilhar(pedido) {
    this.setState({
      visibleDialog: true,
      Prontuario: pedido.Prontuario,
      pacienteId: pedido.Paciente.Id,
      selectedPedido: pedido,
      prazoValue: '8',
      emailCompartilhar: '',
      celCompartilhar: '',
    });
  }

  handleBaixarImagem(pedido) {
    if (pedido === undefined) {
      this.setState({
        pedido: this.state.pedidoSelecionado,
      });
    }

    this.setState({
      selectedPedido: pedido,
      panelImageVisible: false,
      panelImageJpegVisible: false,
      panelLaudoVisible: false,
      panelVisible: false,
      dialogDicomZip: true,
      progressoDicomZip: 0,
    });

    let urlImagens = '';
    if (pedido.Unidade.ServicoImagemPortal.search('studies') > 0) {
      urlImagens = pedido.Unidade.ServicoImagemPortal + '/' + pedido.StudyUid + '.zip';
    } else {
      urlImagens = pedido.Unidade.ServicoImagemPortal + '/studies/' + pedido.StudyId + '/archive';
    }

    let so = '';
    switch (navigator.platform) {
      case 'MacIntel':
        so = 'mac';
        break;
      case 'Linux x86_64':
        so = 'linux';
        break;
      default:
        so = 'windows';
        break;
    }
    const tk = Math.random(new Date().getUTCMilliseconds()).toString().replace('.', '');
    let caminho = `${this.state.caminhoServico}api/Portal/PostDownloadComVisualizador?so=${so}&urlImagens=${urlImagens}&tk=${tk}`;

    const retDominio = () => {
      try {
        const servico = this.state.caminhoServico.split('/Servico');
        return servico[0];
      } catch (ex) {
        return this.state.caminhoServico;
      }
    };
    //let dominioCliente = `${this.state.caminhoServico}`.replace("Servico", "");
    let dominioCliente = retDominio();
    dominioCliente = dominioCliente.replace('https:', '');
    dominioCliente = dominioCliente.replace('http:', '');
    dominioCliente = dominioCliente.replace(/[//"]/g, '');
    var xhr = new XMLHttpRequest();
    cntPgr = 0;
    xhr.addEventListener('progress', updateProgress, false);
    xhr.addEventListener('load', transferComplete, false);
    // progresso
    xhr.addEventListener('progress', event => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        this.setState({ progressoDicomZip: percent });
      }
    });

    // sucesso
    xhr.onload = e => {
      if (xhr.status === 200) {
        const file = new File([xhr.response], 'MyResultApp_Download.zip', {
          type: 'application/zip',
        });
        const exportUrl = URL.createObjectURL(file);
        const fileLink = document.createElement('a');
        fileLink.href = exportUrl;
        fileLink.download = 'MyResultApp_' + tk + '.zip';
        fileLink.click();
      }

      this.setState({ dialogDicomZip: false });
    };

    // erro
    xhr.onerror = () => {
      console.error('Erro no download');
      this.setState({ dialogDicomZip: false });
    };

    xhr.addEventListener('error', transferFailed, false);
    xhr.open('POST', caminho, true);
    xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
    xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
    xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
    xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
    xhr.setRequestHeader(
      'isPacientePortal',
      `${ServiceApi._getHeaders().headers.isPacientePortal}`
    );
    xhr.setRequestHeader(
      'isConvenioPortal',
      `${ServiceApi._getHeaders().headers.isConvenioPortal}`
    );
    xhr.responseType = 'arraybuffer';
    xhr.send();

    this.AdicionarHistoricoAcoes(31, pedido.Id, pedido.Tipo);

    return null;
  }

  handleBaixarDicomZip(pedido) {
    if (!pedido || !pedido.Unidade || !pedido.StudyUid) {
      console.error('Pedido inválido');
      return;
    }

    const urlDicomZip = `${pedido.Unidade.ServicoImagemPortal}/${pedido.StudyUid}.zipAsync`;

    this.setState({
      baixandoDicomZip: true,
      dialogDicomZip: true,
      progressoDicomZip: 0,
    });

    const xhr = new XMLHttpRequest();
    xhr.open('GET', urlDicomZip, true);
    const authHeader = getViewerAuthHeader();
    if (authHeader) xhr.setRequestHeader('Authorization', authHeader);
    xhr.responseType = 'blob';

    // progresso
    xhr.onprogress = event => {
      const bytes = event.loaded;
      const kib = bytes / 1024;

      this.setState({ progressoDicomZip: Math.round(kib) }); // número inteiro
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        const blob = xhr.response;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `dicom_${pedido.StudyUid}.zip`;
        link.click();
        window.URL.revokeObjectURL(url);

        this.AdicionarHistoricoAcoes(31, pedido.Id, pedido.Tipo);
      }
      this.setState({ baixandoDicomZip: false, dialogDicomZip: false });
    };

    xhr.onerror = () => {
      console.error('Erro no download');
      this.setState({ baixandoDicomZip: false, dialogDicomZip: false });
    };

    xhr.send();
  }

  handleAbrirImagem(pedido) {
    if (pedido.StatusImagem === 2) {
      let ultimoLaudoFiltro = {
        PacienteId: pedido.Paciente.Id,
        PacienteNome: pedido.Paciente.Nome,
        PacienteNascimento: pedido.PacienteNascimento,
        PacienteSexo: pedido.PacienteSexo,
        ModalidadeId: pedido.Modalidade.Id,
        DataCadastro: pedido.DataCadastro,
      };
      this.pedidoservice.obterUltimosLaudosComStudyUid(ultimoLaudoFiltro).then(data => {
        this.setState({
          imagensVinculadas: data.UltimosLaudos,
        });
        this.setState({ modalImagemOutroPedido: true });
        this.setState({ pedidoComImagemVinculadaMedicoExecutante: pedido.MedicoExecutante });
        this.setState({ pedidoComImagemVinculadaMedicoRevisor: pedido.MedicoRevisor });
        this.setState({ pedidoComImagemVinculadaId: pedido.Id });
      });
      return;
    }
    if (this.mobilecheck()) {
      window.open(this.buildViewerUrl(pedido), 'imageFrame');
    } else {
      this.setState({
        selectedPedido: pedido,
        servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
        panelVisible: true,
        panelImageJpegVisible: false,
      });
      const _viewer = this.buildViewerUrl(pedido);

      const embedRemove = document.getElementsByTagName('embed');
      if (embedRemove.length > 0) {
        for (let index = 0; index < embedRemove.length; index++) embedRemove[index].remove();
      }
      const embed = document.createElement('embed');
      embed.src = _viewer;
      embed.width = '100%';
      embed.height = '100%';
      const container = document.getElementById('viewer-container');
      if (container) {
        container.innerHTML = ''; // limpa pra não duplicar
        container.appendChild(embed);
      }

      this.setState({ modalImagemOutroPedido: false });
    }
    this.AdicionarHistoricoAcoes(30, pedido.Id, pedido.Tipo);
    return null;
  }

  handleImprimirLaudo(pedido) {
    if (this.mobilecheck()) return alert(this.props.t('PORTAL.MESSAGE.REPORT_DESKTOP_ONLY'));

    this.pedidoSelecionado = pedido;

    if (this.pedidoSelecionado.ContemAnexoDiagnostico && this.state.isExecutante)
      return this.setState({ modalConfirmaImpressao: true });

    //if(this.pedidoSelecionado.DataRevisado === null || this.pedidoSelecionado.ContemAnexoDiagnostico)
    //return this.confirmaImprimirLaudo(true);

    return this.confirmaImprimirLaudo(true);
  }

  confirmaImprimirLaudo(anexoDiagnostico) {
    if (this.pedidoSelecionado) {
      let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${this.pedidoSelecionado.IdExterno}&anexoDiagnostico=${anexoDiagnostico}`;
      var xhr = new XMLHttpRequest();

      xhr.open('GET', caminho, true);

      xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
      xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
      xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
      xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
      xhr.setRequestHeader(
        'isPacientePortal',
        `${ServiceApi._getHeaders().headers.isPacientePortal}`
      );
      xhr.setRequestHeader(
        'isConvenioPortal',
        `${ServiceApi._getHeaders().headers.isConvenioPortal}`
      );

      xhr.responseType = 'arraybuffer';
      xhr.onload = function (e) {
        if (this.status == 200) {
          var blob = new Blob([this.response], { type: 'application/pdf' });
          var pdfUrl = URL.createObjectURL(blob);
          print(pdfUrl);
        }
      };
      xhr.send();
      this.AdicionarHistoricoAcoes(38, this.pedidoSelecionado.Id, this.pedidoSelecionado.Tipo);
    }
    return null;
  }

  abrirLaudo = pedido => {
    if (!pedido || pedido.laudoJaCarregado) return;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isMobile = isAndroid || isIOS;

    if (!isMobile) {
      const anexo = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
      const url = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${anexo}`;
      const headers = ServiceApi._getHeaders().headers;

      this.setState({ urlLaudoPdf: null, laudoCarregando: true });

      fetch(url, {
        method: 'GET',
        headers: {
          user: headers.user,
          Cnonce: headers.Cnonce,
          Token: headers.Token,
          TokenPortal: headers.TokenPortal,
          isPacientePortal: headers.isPacientePortal,
          isConvenioPortal: headers.isConvenioPortal,
        },
      })
        .then(r => r.blob())
        .then(blob => {
          const pdfUrl = URL.createObjectURL(blob);
          this.setState({ urlLaudoPdf: pdfUrl, laudoCarregando: false }, this.atualizarZoomPDF);
          pedido.laudoJaCarregado = true;
        })
        .catch(() => {
          this.setState({ urlLaudoPdf: null, laudoCarregando: false });
        });
    } else {
      let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
      let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;
      var xhr = new XMLHttpRequest();
      cntPgr = 0;
      pgrBarCont = setInterval(viewPgrContinuous, 30);
      xhr.addEventListener('progress', updateProgress, false);
      xhr.addEventListener('load', transferComplete, false);
      xhr.addEventListener('error', transferFailed, false);

      xhr.open('Get', caminho, true);

      xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
      xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
      xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
      xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
      xhr.setRequestHeader(
        'isPacientePortal',
        `${ServiceApi._getHeaders().headers.isPacientePortal}`
      );
      xhr.setRequestHeader(
        'isConvenioPortal',
        `${ServiceApi._getHeaders().headers.isConvenioPortal}`
      );

      xhr.responseType = 'arraybuffer';

      this.setState({ laudoPdfData: null, laudoCarregando: true });

      xhr.onload = () => {
        if (xhr.status === 200) {
          this.setState({ laudoPdfData: xhr.response, laudoCarregando: false });
          pedido.laudoJaCarregado = true;
        } else {
          this.setState({ laudoPdfData: null, laudoCarregando: false });
        }
      };
      xhr.onerror = () => {
        this.setState({ laudoPdfData: null, laudoCarregando: false });
      };
      xhr.send();
    }
  };

  handleAbrirLaudo(pedido) {
    if (this.mobilecheck()) {
      let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
      let caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;
      //window.open(caminho, "LaudoFrame"); //Abrir em nova aba
      var xhr = new XMLHttpRequest();
      cntPgr = 0;
      pgrBarCont = setInterval(viewPgrContinuous, 30);
      xhr.addEventListener('progress', updateProgress, false);
      xhr.addEventListener('load', transferComplete, false);
      xhr.addEventListener('error', transferFailed, false);

      xhr.open('Get', caminho, true);

      xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
      xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
      xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
      xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
      xhr.setRequestHeader(
        'isPacientePortal',
        `${ServiceApi._getHeaders().headers.isPacientePortal}`
      );
      xhr.setRequestHeader(
        'isConvenioPortal',
        `${ServiceApi._getHeaders().headers.isConvenioPortal}`
      );

      xhr.responseType = 'arraybuffer';
      xhr.onload = function (e) {
        if (this.status == 200) {
          var file = new File([this.response], `Laudo_${pedido.IdExterno}.pdf`, {
            type: 'application/pdf',
          });
          var exportUrl = URL.createObjectURL(file);
          var fileLink = document.createElement('a');
          fileLink.href = exportUrl;
          fileLink.download = `Laudo_${pedido.Id}.pdf`;
          fileLink.click();
        }
      };
      xhr.send();
    } else {
      this.setState({
        selectedPedido: pedido,
        panelVisible: true,
        panelAnexoVisible: false,
      });

      let _anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;

      const caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${_anexoDiagnostico}`;

      const embedRemove = document.getElementsByTagName('embed');

      if (embedRemove.length > 0) {
        for (let index = 0; index < embedRemove.length; index++) embedRemove[index].remove();
      }

      const headers = new Headers();
      headers.append('user', `${ServiceApi._getHeaders().headers.user}`);
      headers.append('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
      headers.append('Token', `${ServiceApi._getHeaders().headers.Token}`);
      headers.append('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
      headers.append('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
      headers.append('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);

      const requestOptions = {
        method: 'GET',
        headers: headers,
      };

      const embed = document.createElement('embed');

      fetch(caminho, requestOptions)
        .then(response => {
          return response.blob();
        })
        .then(blob => {
          embed.src = URL.createObjectURL(blob);
          document.getElementById(`divLaudo-${pedido.Id}`).append(embed);
        })
        .catch(error => {
          console.error('Erro na requisição:', error);
        });

      embed.width = '100%';
      embed.height = '100%';

      this.setDialogContentSize();

      this.onScrollIntoView(`divLaudo-${pedido.Id}`);
    }
    this.AdicionarHistoricoAcoes(28, pedido.Id, pedido.Tipo);
    return null;
  }

  onScrollIntoView(el) {
    setTimeout(() => {
      document.getElementById(el).scrollIntoView();
      const _scrollTop = document.scrollingElement.scrollTop.toFixed() - 200;
      window.scroll(0, _scrollTop);
    }, 200);
  }

  setDialogContentSize = () => {
    try {
      const pDialogContent = document.getElementsByClassName('p-panel-content')[0];
      const embed = document.getElementsByTagName('embed')[0];
      pDialogContent.style.padding = '0';
      embed.style.height = `${pDialogContent.clientHeight}px`;
    } catch (ex) {}
  };

  async handleAbrirGaleriaDeImagens(pedido) {
    try {
      const possuiJob = await listarJob(pedido.AcNumber);
      // const possuiJob = false;

      if (possuiJob.length > 0) {
        sessionStorage.setItem('pedido', JSON.stringify(pedido));
        this.props.history.push({
          pathname: '/Jobs',
        });
      } else {
        this.setState({
          selectedPedido: pedido,
          servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
          panelImageJpegVisible: true,
        });
        this.AdicionarHistoricoAcoes(29, pedido.Id, pedido.Tipo);
      }
    } catch (error) {
      console.error('Erro ao listar jobs:', error);
      alert(this.props.t('PORTAL.MESSAGE.SERVER_CONNECTION_ERROR'));
      this.props.location.href = '#/portal';
    }
  }

  handleAbrirModalExamesExternos = async opcao => {
    if (opcao === 'Exames externos') {
      try {
        this.setState({
          modalExamesExternosVisivel: true, // abre a modal
        });
      } catch (error) {
        console.error('Erro ao buscar exames externos:', error);
        this.setState({ modalExamesExternosVisivel: true }); // ainda abre, mas sem dados
      }
    } else {
      this.setState({ modalExamesExternosVisivel: true });
    }
  };

  // Helper: mapeia a aba para a operação do histórico
  getOperacaoHistorico = opcao => {
    switch (opcao) {
      case 'Parecer':
        return 33;
      case 'Galeria':
        return 29;
      case 'Compartilhar':
        return 32;
      case 'Laudo':
        return 46;
      case 'Anexos':
        return 34;
      default:
        return 29;
    }
  };

  handleAbrirModalGenerica = (pedido, opcao) => {
    pedido.laudoJaCarregado = false;

    if (opcao === 'Viewer' && !pedido.StudyUid && pedido.possuiJob) opcao = 'Galeria';

    const isExterno = pedido.Tipo === 'externo';
    const operacao = this.getOperacaoHistorico(opcao);

    // limpa lista de anexos anterior
    let _listaAnexos = [];
    if (pedido?.Anexos?.Anexos) {
      _listaAnexos = [...pedido.Anexos.Anexos];
    }

    this.setState({
      modalOpcoesVisivel: true,
    });

    // state inicial comum a todos os tipos
    this.setState(
      {
        listaAnexos: _listaAnexos,
        selectedPedido: pedido,
        pedidoModalOpcoes: pedido,
        modalOpcaoSelecionada: opcao,
        validadeSelecionada:
          opcao === 'Compartilhar'
            ? defaultValidadeCompartilhamento
            : this.state.validadeSelecionada,
        listaParecer: [],
      },
      () => {
        // === Histórico ===
        if (operacao) this.AdicionarHistoricoAcoes(operacao, pedido.Id, pedido.Tipo);

        // === Parecer ===
        if (opcao === 'Parecer') {
          const medicoService = new MedicoService();
          medicoService
            .GetParecerMedico(pedido.Id)
            .then(data => {
              const _listaParecer = data.Comentarios.map(el => ({
                DataCadastro: moment(el.DataCadastro).format('DD/MM/YYYY'),
                Prioridade: this.retLegendaPrioridade(el.Prioridade),
                Texto: el.Texto,
              }));
              this.setState({ listaParecer: _listaParecer });
            })
            .catch(error => console.log('Erro ao buscar parecer médico:', error));
        }

        // === Viewer ===
        if (opcao === 'Viewer') {
          this.abrirViewer(pedido);
        }

        // === Laudo ===
        if (opcao === 'Laudo') {
          this.abrirLaudo(pedido);
        }
      }
    );
  };

  async handleAbrirModalVisualizador(pedido, tipo) {
    try {
      const possuiJob = await listarJob(pedido.AcNumber);

      if (possuiJob.length > 0) {
        sessionStorage.setItem('pedido', JSON.stringify(pedido));
        this.props.history.push({ pathname: '/Jobs' });
      } else {
        this.setState({
          selectedPedido: pedido,
          servicoImagemPortal: pedido.Unidade.ServicoImagemPortal,
          tipoVisualizador: tipo, // <- pode ser 'imagem', 'laudo', 'dicom', etc.
          panelVisualizadorVisible: true,
        });
        this.AdicionarHistoricoAcoes(29, pedido.Id, pedido.Tipo);
      }
    } catch (error) {
      console.error('Erro ao listar jobs:', error);
      alert(this.props.t('PORTAL.MESSAGE.SERVER_CONNECTION_ERROR'));
      this.props.location.href = '#/portal';
    }
  }

  handleCompartilharLinkPortal() {
    const pedido = this.state.pedidoModalOpcoes;

    if (!pedido || !pedido.Unidade) {
      console.error('Pedido ou Unidade está indefinido:', pedido);
      return;
    }

    const tipoCompartilhamento = this.state.formaEnvio === 'whatsapp' ? 0 : 1;
    let urlAcesso = `${window.location.origin}${window.location.pathname}`;
    urlAcesso = urlAcesso.replace(/^https?:\/\//, ''); // remove protocolo da URL

    const cel = this.state.celCompartilhar;
    const email = this.state.emailCompartilhar || '';
    const prazoRaw = this.state.validadeSelecionada;

    const prazo = parseInt(prazoRaw, 10) || 8; // valor padrão caso o parse falhe

    const cnonce = Math.random().toString().slice(2); // string aleatória sem ponto
    const unidadeId = pedido?.Unidade?.Id || pedido?.UnidadeId || 0;
    const pacienteId = pedido?.IdPaciente || pedido?.Paciente?.Id || 0;

    if (!pacienteId) {
      alert(this.props.t('PORTAL.MESSAGE.PATIENT_NOT_FOUND'));
      return;
    }

    if (tipoCompartilhamento === 1 && (!email || !email.includes('@'))) {
      alert(this.props.t('PORTAL.MESSAGE.VALID_EMAIL_REQUIRED'));
      return;
    }

    if (tipoCompartilhamento === 0 && (!cel || cel.length < 8)) {
      alert(this.props.t('PORTAL.MESSAGE.VALID_PHONE_REQUIRED'));
      return;
    }

    // Caminho da URL (assumindo que ServiceApi já tem baseURL configurada corretamente)
    const url =
      `/api/Portal/PostCompartilharLinkPortal/?` +
      `prontuario=${encodeURIComponent(pedido.Prontuario)}` +
      `&pacienteId=${pacienteId}` +
      `&url=${encodeURIComponent(urlAcesso)}` +
      `&email=${encodeURIComponent(email)}` +
      `&prazo=${prazo}` +
      `&cnonce=${encodeURIComponent(cnonce)}` +
      `&tipoCompartilhamento=${tipoCompartilhamento}` +
      `&unidadeId=${unidadeId}` +
      `&pedidoId=${pedido.Id}`;

    this.AdicionarHistoricoAcoes(32, pedido.Id, pedido.Tipo);

    console.log(' Compartilhamento', {
      prontuario: pedido.Prontuario,
      pacienteId,
      urlCompleta: url,
    });

    return ServiceApi.post(url)
      .then(res => {
        const mensagem = typeof res === 'string' ? res : res?.data || '';

        if (tipoCompartilhamento === 0) {
          let texto = mensagem.replace('http:', 'https:');
          let numero = cel.replace(/[-()\s]/g, '');

          if (numero) {
            numero = `+55${numero}`;
            const linkWhatsapp = document.createElement('a');
            linkWhatsapp.href = `https://${this.mobilecheck() ? 'api' : 'web'}.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(texto)}`;
            linkWhatsapp.target = this.mobilecheck() ? '' : '_blank';
            document.body.appendChild(linkWhatsapp);
            linkWhatsapp.click();
            linkWhatsapp.remove();
          } else {
            alert(this.props.t('PORTAL.MESSAGE.SHARE_PHONE_REQUIRED'));
          }
        } else {
          alert(mensagem);
        }

        this.setState({
          modalOpcoesVisivel: false,
          validadeSelecionada: defaultValidadeCompartilhamento,
          emailCompartilhar: '',
          celCompartilhar: '',
        });
      })
      .catch(err => {
        console.error('Erro ao compartilhar:', err);
        alert(this.props.t('PORTAL.MESSAGE.SHARE_ERROR'));
      });
  }

  toggleFiltro = () => {
    if (this.state.isAcessoCompartilhado) {
      return;
    }
    this.setState(prevState => ({
      mostrarFiltro: !prevState.mostrarFiltro,
    }));
  };

  handleFilterKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleBuscarClick();
    }
  };

  handlePeriodoChange = e => {
    const value = e.value;
    const hoje = new Date();
    let novaDataInicial = this.state.dataInicial;
    let novaDataFinal = this.state.dataFinal;

    if (value === 'ultimos30') {
      novaDataFinal = hoje;
      novaDataInicial = new Date();
      novaDataInicial.setDate(novaDataFinal.getDate() - 30);
    } else if (value === 'ultimos90') {
      novaDataFinal = hoje;
      novaDataInicial = new Date();
      novaDataInicial.setDate(novaDataFinal.getDate() - 90);
    } else if (value === 'ultimosN') {
      const dias = this.state.diasPesquisaInicialAoLogarMedico || 0;
      novaDataFinal = hoje;
      novaDataInicial = new Date();
      novaDataInicial.setDate(novaDataFinal.getDate() - dias);
    }

    if (value === 'personalizado') {
      const ultimaInicial = localStorage.getItem('ultimaDataInicialPersonalizada');
      const ultimaFinal = localStorage.getItem('ultimaDataFinalPersonalizada');

      if (ultimaInicial && ultimaFinal) {
        novaDataInicial = new Date(ultimaInicial);
        novaDataFinal = new Date(ultimaFinal);
      }
    }

    this.setState({
      periodoSelecionado: value,
      dataInicial: novaDataInicial,
      dataFinal: novaDataFinal,
      usarRangeDataPaciente: true,
    });
  };

  handleModalidadeChange = e => {
    const value = e.value;

    this.setState({
      modalidadeSelecionada: value,
    });
  };

  handleDataInicialChange = e => {
    const novaDataInicial = e.value;
    const dataFinalAtual = this.state.dataFinal;
    const dataInvalida = new Date(novaDataInicial) > new Date(dataFinalAtual);

    localStorage.setItem('ultimaDataInicialPersonalizada', novaDataInicial);
    localStorage.setItem('ultimaDataFinalPersonalizada', this.state.dataFinal);

    this.setState({
      dataInicial: novaDataInicial,
      periodoSelecionado: 'personalizado',
      dataInicialInvalida: dataInvalida,
      dataFinalInvalida: dataInvalida,
      usarRangeDataPaciente: true,
    });
  };

  handleDataFinalChange = e => {
    const novaDataFinal = e.value;
    const dataInicialAtual = this.state.dataInicial;
    const dataInvalida = new Date(dataInicialAtual) > new Date(novaDataFinal);

    localStorage.setItem('ultimaDataFinalPersonalizada', novaDataFinal);
    localStorage.setItem('ultimaDataInicialPersonalizada', this.state.dataInicial);

    this.setState({
      dataFinal: novaDataFinal,
      periodoSelecionado: 'personalizado',
      dataInicialInvalida: dataInvalida,
      dataFinalInvalida: dataInvalida,
      usarRangeDataPaciente: true,
    });
  };

  handlePesquisarExamesExternos = e => {
    if (this.state.isAcessoCompartilhado) {
      this.setState({ pesquisarExamesExternos: false });
      return;
    }

    const value = e.value;

    this.setState({
      pesquisarExamesExternos: value,
    });
  };

  handleBuscarClick = () => {
    const { nomeExame, modalidadeSelecionada, dataInicial, dataFinal, procedimentoSelecionadoId } =
      this.state;
    const usarRangeData = this.deveUsarRangeData();

    const filtro = {
      paciente: '',
      acNumber: '',
      prontuario: '',
      modalidades: [],
      selectedProcedimentoId: null,
      dataInicial: usarRangeData ? dataInicial : '',
      dataFinal: usarRangeData ? dataFinal : '',
    };

    if (this.isPerfilMedico()) {
      const texto = nomeExame?.trim();

      if (!texto) {
      } else if (/^\p{L}+$/u.test(texto) || texto.includes(' ')) {
        filtro.paciente = texto;
      } else {
        filtro.acNumber = texto;
      }
    } else {
      filtro.selectedProcedimentoId = procedimentoSelecionadoId;

      if (modalidadeSelecionada?.Modalidade !== undefined) {
        filtro.modalidades = modalidadeSelecionada ? [modalidadeSelecionada.Modalidade] : [];
      }
    }

    // Ativa o loading
    this.setState({ isLoading: true }, () => {
      this.onExecuteFiltro(filtro);
    });
  };

  handleIncluirExamesExternos = async () => {
    const {
      descricaoExame,
      dataExameExterno,
      localExameExterno,
      arquivosSelecionados,
      medicoSolicitanteExameExterno,
      crmMedicoSolicitanteExameExterno,
      zipDicom,
      UsuarioId,
      procedimentoSelecionado,
    } = this.state;

    const erroDescricao = !procedimentoSelecionado?.Id || !descricaoExame?.trim();
    const erroData = !dataExameExterno;
    const erroLocal = !localExameExterno?.trim();
    const erroArquivos = arquivosSelecionados.length === 0 && !zipDicom;
    const pedidoPacienteID = UsuarioId;

    if (erroDescricao || erroData || erroLocal || erroArquivos || !pedidoPacienteID) {
      this.setState({
        erroDescricao,
        erroData,
        erroLocal,
        erroCamposObrigatorios: erroDescricao || erroData || erroLocal,
        erroArquivos,
      });
      return;
    }

    const dataExame = new Date(dataExameExterno);
    const mes = String(dataExame.getMonth() + 1).padStart(2, '0');
    const dia = String(dataExame.getDate()).padStart(2, '0');

    const formData = new FormData();
    formData.append('pacienteId', String(pedidoPacienteID));
    formData.append('dataExame', `${dataExame.getFullYear()}-${mes}-${dia}`);
    formData.append('procedimentoId', String(procedimentoSelecionado.Id));
    formData.append('descricaoExame', descricaoExame);
    formData.append('nomeInstituicao', localExameExterno);
    formData.append('nomeMedicoSolicitante', medicoSolicitanteExameExterno);
    formData.append('crmMedicoSolicitante', crmMedicoSolicitanteExameExterno);

    formData.append('usuario', '0');
    formData.append('acao', 'portal');

    arquivosSelecionados.forEach(file => {
      if (file) formData.append('file', file);
    });

    if (zipDicom) {
      formData.append('dicom', zipDicom);
    }

    try {
      this.setState({
        resultadoInclusaoVisivel: true,
        resultadoInclusaoMensagem: this.props.t('PORTAL.MESSAGE.INCLUDING_EXTERNAL_EXAMS'),
        resultadoInclusaoTipo: 'carregando',
      });

      const headers = new Headers();
      const authHeaders = ServiceApi._getHeaders().headers;

      headers.append('user', authHeaders.user);
      headers.append('Cnonce', authHeaders.Cnonce);
      headers.append('Token', authHeaders.Token);
      headers.append('TokenPortal', authHeaders.TokenPortal);
      headers.append('isPacientePortal', authHeaders.isPacientePortal);
      headers.append('isConvenioPortal', authHeaders.isConvenioPortal);

      delete headers['Content-Type'];
      if (!headers.TokenPortal) delete headers.TokenPortal;

      const response = await fetch(
        `${this.state.caminhoServico}Api/PedidoExterno/PostPedidoExterno`,
        {
          method: 'POST',
          headers,
          body: formData,
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Erro no envio (status):', response.status);
        console.error('Detalhes do erro:', errorText);

        const erro = new Error(errorText || 'Erro no envio');
        erro.status = response.status;
        throw erro;
      }

      this.setState({
        resultadoInclusaoMensagem: this.props.t('PORTAL.MESSAGE.EXTERNAL_EXAMS_INCLUDED'),
        resultadoInclusaoTipo: 'sucesso',
        arquivosSelecionados: [],
        descricaoExame: '',
        procedimentoSelecionado: null,
        dataExameExterno: '',
        localExameExterno: '',
        //arquivosSelecionados: '',
        //medicoSolicitanteExameExterno: '',
        //crmMedicoSolicitanteExameExterno: '',
        zipDicom: null,
        //pedidoModalOpcoes: '',
        caminhopastaDicomExameExterno: '',

        erroArquivos: false,
        erroCamposObrigatorios: false,
        erroDescricao: false,
        erroLocal: false,
        erroData: false,
        modalExamesExternosVisivel: false,
      });
    } catch (error) {
      console.error('Erro ao incluir exames:', error);

      this.setState({
        resultadoInclusaoMensagem:
          this.extrairMensagemErroApi(error) ||
          this.props.t('PORTAL.MESSAGE.EXTERNAL_EXAMS_INCLUDE_ERROR'),
        resultadoInclusaoTipo: 'erro',
      });
    }
  };

  // Apenas o 400 traz mensagem de validacao escrita para o usuario, no formato
  // { "Message": "..." }. Os demais status devolvem o texto da excecao do servidor,
  // que nao deve ser exibido na tela.
  extrairMensagemErroApi = error => {
    if (error?.status !== 400) return '';

    try {
      return JSON.parse(error?.message)?.Message || '';
    } catch {
      return '';
    }
  };

  handleSelecionarPastaDicom = async event => {
    const files = Array.from(event.target.files);
    const zip = new JSZip();

    this.setState({ zipandoDicom: true }); //Exibe o spinner

    for (const file of files) {
      const relativePath = file.webkitRelativePath || file.name;
      zip.file(relativePath, file);
    }

    try {
      const conteudoZip = await zip.generateAsync({ type: 'blob' });
      const zipFile = new File([conteudoZip], 'dicom.zip', { type: 'application/zip' });

      this.setState({
        zipDicom: zipFile,
        caminhopastaDicomExameExterno:
          files[0]?.webkitRelativePath?.split('/')[0] || 'Pasta selecionada',
        zipandoDicom: false, //Esconde o spinner
      });

      console.log('ZIP DICOM gerado com sucesso');
    } catch (error) {
      console.error('Erro ao zipar pasta DICOM:', error);
      alert(this.props.t('PORTAL.MESSAGE.ZIP_ERROR'));
      this.setState({ zipandoDicom: false });
    }
  };

  visualizarAnexoStl(pedido) {
    const auth = JSON.parse(sessionStorage.getItem('auth'));

    const user = auth?.Login;
    const cnonce = auth?.Cnonce;
    let token = md5((user || '').toLowerCase() + cnonce + auth?.Token);
    let isPacientePortal = false;
    let tokenPortal = '';

    if (auth.IdMedico === 0) {
      token = auth?.Md5;
      isPacientePortal = true;
      tokenPortal = auth?.TokenPortal == null ? '' : auth?.TokenPortal;
    }

    if (!user || !token || !cnonce) {
      console.error('Dados de autenticação ausentes no sessionStorage:', { user, token, cnonce });
      return;
    }

    const payload = {
      user: user,
      token: token,
      cnonce: cnonce,
      isPacientePortal: isPacientePortal,
      tokenPortal: tokenPortal,
    };

    const base64Payload = btoa(JSON.stringify(payload));

    const protocolo = window.location.protocol;
    const host = window.location.hostname;
    const baseUrl = `${protocolo}//${host}`;

    const viewerUrl = `${baseUrl}/Viewer3D/?id=${pedido.Id}&data=${base64Payload}`;

    window.open(viewerUrl);
    this.AdicionarHistoricoAcoes(34, pedido.Id, pedido.Tipo);
  }

  visualizarAnexo(rowData) {
    const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      // Abre direto — Safari mostrará o PDF/arquivo e o usuário pode "Salvar em Arquivos"
      window.open(downloadUrl, '_blank');
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', downloadUrl, true);
    xhr.responseType = 'blob';

    // Adiciona headers de autenticação como nos outros m.étodos
    const headers = ServiceApi._getHeaders().headers;
    xhr.setRequestHeader('user', headers.user);
    xhr.setRequestHeader('Cnonce', headers.Cnonce);
    xhr.setRequestHeader('Token', headers.Token);
    xhr.setRequestHeader('TokenPortal', headers.TokenPortal);
    xhr.setRequestHeader('isPacientePortal', headers.isPacientePortal);
    xhr.setRequestHeader('isConvenioPortal', headers.isConvenioPortal);

    xhr.onload = function () {
      if (xhr.status === 200) {
        const blob = xhr.response;
        const fileURL = URL.createObjectURL(blob);

        // Abre a visualização do anexo
        window.open(fileURL, 'AnexoFrame');
      } else {
        console.error('Erro ao visualizar anexo:', xhr.status);
      }
    };

    xhr.onerror = function () {
      console.error('Erro de rede ao tentar visualizar anexo.');
    };

    xhr.send();

    // Histórico da operação
    let operacao = rowData.TipoAnexo === 1 ? 36 : 34;
    this.AdicionarHistoricoAcoes(
      operacao,
      this.state.selectedPedido.Id,
      this.state.selectedPedido.Tipo
    );
  }

  downloadAnexo(rowData) {
    const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      alert(this.props.t('PORTAL.MESSAGE.IOS_DOWNLOAD_HINT'));
      // Abre direto — Safari mostrará o PDF/arquivo e o usuário pode "Salvar em Arquivos"
      window.open(downloadUrl, '_blank');
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', downloadUrl, true);
    xhr.responseType = 'blob';

    // Setando os headers de autenticação manualmente
    const headers = ServiceApi._getHeaders().headers;
    xhr.setRequestHeader('user', headers.user);
    xhr.setRequestHeader('Cnonce', headers.Cnonce);
    xhr.setRequestHeader('Token', headers.Token);
    xhr.setRequestHeader('TokenPortal', headers.TokenPortal);
    xhr.setRequestHeader('isPacientePortal', headers.isPacientePortal);
    xhr.setRequestHeader('isConvenioPortal', headers.isConvenioPortal);

    xhr.onload = function () {
      if (xhr.status === 200) {
        var blob = xhr.response;
        var fileName = rowData.Nome;
        var tempEl = document.createElement('a');
        document.body.appendChild(tempEl);
        tempEl.style = 'display: none';
        let url = window.URL.createObjectURL(blob);
        tempEl.href = url;
        tempEl.download = fileName;
        tempEl.click();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Erro no download do anexo:', xhr.status, xhr.responseText);
      }
    };

    xhr.onerror = function () {
      console.error('Erro de rede ou CORS ao tentar baixar o anexo.');
    };

    xhr.send();

    // Adiciona histórico
    let operacao = rowData.TipoAnexo === 1 ? 37 : 35;
    this.AdicionarHistoricoAcoes(
      operacao,
      this.state.selectedPedido.Id,
      this.state.selectedPedido.Tipo
    );
  }

  onHide(name) {
    this.setState({
      [`${name}`]: false,
    });
  }

  exibirLaudoNaDiv(pedido) {
    if (!pedido) return;

    const anexoDiagnostico = pedido.DataRevisado === null || pedido.ContemAnexoDiagnostico;
    const caminho = `${this.state.caminhoServico}api/Portal/GetResultadoPdf?id=${pedido.IdExterno}&anexoDiagnostico=${anexoDiagnostico}`;

    const headers = new Headers();
    const authHeaders = ServiceApi._getHeaders().headers;

    headers.append('user', authHeaders.user);
    headers.append('Cnonce', authHeaders.Cnonce);
    headers.append('Token', authHeaders.Token);
    headers.append('TokenPortal', authHeaders.TokenPortal);
    headers.append('isPacientePortal', authHeaders.isPacientePortal);
    headers.append('isConvenioPortal', authHeaders.isConvenioPortal);

    const requestOptions = {
      method: 'GET',
      headers: headers,
    };

    fetch(caminho, requestOptions)
      .then(response => response.blob())
      .then(blob => {
        const embed = document.createElement('embed');
        embed.src = URL.createObjectURL(blob);
        embed.type = 'application/pdf';
        embed.width = '100%';
        embed.height = '100%';
        const divLaudo = document.getElementById(`divLaudo-${pedido.Id}`);
        if (divLaudo) {
          divLaudo.innerHTML = '';
          divLaudo.appendChild(embed);
        }
      })
      .catch(error => {
        console.error('Erro ao exibir o laudo:', error);
      });
  }

  mostrarBotaoLaudoNaModal(pedido) {
    const btnLaudoDisabledSemServico = this.DesabilitarBtnLaudoSemServico(pedido);
    const btnLaudoDisabled =
      this.state.isMedico & btnLaudoDisabledSemServico
        ? btnLaudoDisabledSemServico
        : this.DesabilitarBtnLaudo(pedido);

    return !btnLaudoDisabled;
  }

  mostrarBotao(pedido) {
    return pedido?.tipo !== 'externo';
  }

  handleArquivoSelecionado = e => {
    const arquivos = e.files || [];

    this.setState({
      arquivosSelecionados: arquivos,
      arquivosEnviadosViaUpload: arquivos.length > 0,
    });
  };

  visualizarArquivo = arquivo => {
    const url = URL.createObjectURL(arquivo);
    window.open(url, '_blank');
  };

  removerArquivo = index => {
    const novaLista = [...this.state.arquivosSelecionados];
    novaLista.splice(index, 1);
    this.setState({ arquivosSelecionados: novaLista });
  };

  //#endregion

  //RENDERS SECUNDÁRIOS
  //#region RENDERS SECUNDÁRIOS

  renderAcoesArquivoExterno = file => {
    const pedidoId = this.state.pedidoModalOpcoes?.Id;
    if (!pedidoId) return null;

    const visualizar = async () => {
      try {
        const response = await this.pedidoservice.getArquivoExterno(pedidoId, file.Name);

        const fileName = file.Name.toLowerCase();
        let tipoForcado = 'application/octet-stream';
        if (fileName.endsWith('.pdf')) tipoForcado = 'application/pdf';
        else if (fileName.endsWith('.png')) tipoForcado = 'image/png';
        else if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg'))
          tipoForcado = 'image/jpeg';
        else if (fileName.endsWith('.bmp')) tipoForcado = 'image/bmp';

        const blob = new Blob([response.data], { type: tipoForcado });
        const url = URL.createObjectURL(blob);

        // PDF: precisa de uma forma segura para abrir
        if (tipoForcado === 'application/pdf') {
          // alguns navegadores bloqueiam window.open com PDF
          const novaAba = window.open();
          novaAba.document.write(`
                <html>
                    <body style="margin:0">
                        <embed src="${url}" type="application/pdf" width="100%" height="100%" />
                    </body>
                </html>
            `);
        } else {
          window.open(url, '_blank');
        }

        setTimeout(() => URL.revokeObjectURL(url), 10000);
      } catch (err) {
        console.error('Erro ao visualizar:', err);
      }
    };

    const baixar = async () => {
      try {
        const response = await this.pedidoservice.getArquivoExterno(pedidoId, file.Name);

        // Detecta o tipo (pelo nome, já que Content-Type pode ser inconsistente)
        const fileName = file.Name.toLowerCase();
        let tipoForcado = 'application/octet-stream';
        if (fileName.endsWith('.pdf')) tipoForcado = 'application/pdf';
        if (fileName.endsWith('.png')) tipoForcado = 'image/png';
        if (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) tipoForcado = 'image/jpeg';
        if (fileName.endsWith('.bmp')) tipoForcado = 'image/bmp';

        const blob = new Blob([response.data], { type: tipoForcado });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = file.Name || 'arquivo'; // usa o nome real
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => URL.revokeObjectURL(url), 10000);
      } catch (err) {
        console.error('Erro ao baixar arquivo externo:', err);
      }
    };

    return (
      <div style={{ display: 'flex', gap: '0.5em' }}>
        <Button
          icon="pi pi-eye"
          className="p-button-text p-button-sm"
          onClick={visualizar}
          tooltip={this.props.t('PORTAL.BUTTON.VIEW')}
          tooltipOptions={{ position: 'top' }}
        />
        <Button
          icon="pi pi-download"
          className="p-button-text p-button-sm"
          onClick={baixar}
          tooltip={this.props.t('PORTAL.BUTTON.DOWNLOAD')}
          tooltipOptions={{ position: 'top' }}
        />
      </div>
    );
  };

  renderListItem(pedido) {
    return <StudyCard pedido={pedido} parent={this} />;
  }

  renderListItemExterno(pedido) {
    return <ExternalStudyCard pedido={pedido} parent={this} />;
  }

  itemTemplate(pedido, layout) {
    if (!pedido) return null;

    if (pedido.Tipo === 'externo') {
      return this.renderListItemExterno(pedido);
    } else {
      return this.renderListItem(pedido);
    }
  }

  renderPedidoDialogContent() {
    if (this.state.selectedPedido) {
      return (
        <div className="p-grid" style={{ fontSize: '16px', textAlign: 'center', padding: '20px' }}>
          <div className="p-col-12" style={{ textAlign: 'center' }}>
            {/* <img src={'showcase/resources/demo/images/car/${this.state.selectedCar.brand}.png'} alt={this.state.selectedCar.brand} /> */}
          </div>
          <div className="p-col-4">{this.props.t('PORTAL.FILTER.PATIENT_NAME')} </div>
          <div className="p-col-8">{this.state.selectedPedido.Paciente?.Nome || ''}</div>

          <div className="p-col-4">{this.props.t('PORTAL.FILTER.PROCEDURE')}: </div>
          <div className="p-col-8">{this.state.selectedPedido.Procedimento?.Nome || ''}</div>

          <div className="p-col-4">{this.props.t('PORTAL.CARD.PERFORMING_DOCTOR')}: </div>
          <div className="p-col-8">{this.state.selectedPedido.MedicoExecutante?.Nome || ''}</div>

          <div className="p-col-4">{this.props.t('PORTAL.CARD.REVIEWING_DOCTOR')}: </div>
          <div className="p-col-8">{this.state.selectedPedido.MedicoRevisor?.Nome || ''}</div>

          <div className="p-col-4">{this.props.t('PORTAL.FILTER.MODALITY')} </div>
          <div className="p-col-8">{this.state.selectedPedido.Modalidade?.Nome || ''}</div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderHeaderFilter() {
    if (this.state.isAcessoCompartilhado) {
      return null;
    }

    const { t } = this.props;
    const classeFiltro = `filter-bar ${this.state.mostrarFiltro ? 'aberto' : ''}`;

    const perfilAtual = this.RetPerfil();
    const isPerfilMedico =
      perfilAtual === 'Médico Executante' || perfilAtual === 'Médico Solicitante';
    const diasPeriodo = this.state.diasPesquisaInicialAoLogarMedico;

    const periodoOptions = [
      { label: t('PORTAL.FILTER.CUSTOM'), value: 'personalizado' },
      ...(isPerfilMedico && diasPeriodo > 0
        ? [
            {
              label:
                diasPeriodo === 1
                  ? t('PORTAL.FILTER.PREVIOUS_DAY')
                  : t('PORTAL.FILTER.LAST_N_DAYS', { count: diasPeriodo }),
              value: 'ultimosN',
            },
          ]
        : []),
      { label: t('PORTAL.FILTER.LAST_30_DAYS'), value: 'ultimos30' },
      { label: t('PORTAL.FILTER.LAST_90_DAYS'), value: 'ultimos90' },
    ];

    return (
      <div className={classeFiltro}>
        <div className="filter-bar__left" onKeyDown={this.handleFilterKeyDown}>
          {this.RetPerfil() !== 'Médico Executante' && (
            <div className="filter-bar__search">
              <p className="filter-bar__search-label">{t('PORTAL.FILTER.EXAM_NAME')}</p>
              <InputText
                className="filter-bar__search-input"
                value={this.state.nomeExame}
                onChange={e => this.setState({ nomeExame: e.target.value })}
              />
            </div>
          )}

          {this.RetPerfil() === 'Médico Executante' && (
            <div className="filter-bar__search">
              <p className="filter-bar__search-label">{t('PORTAL.FILTER.PATIENT_ACNUMBER')}</p>
              <InputText
                className="filter-bar__search-input"
                value={this.state.nomeExame}
                onChange={e => this.setState({ nomeExame: e.target.value })}
              />
            </div>
          )}

          <div className="filter-bar__range-desktop">
            <p className="filter-bar__range-label">{t('PORTAL.FILTER.PERIOD')}</p>
            <Dropdown
              className="filter-bar__range-dropdown"
              value={this.state.periodoSelecionado}
              options={periodoOptions}
              optionLabel="label"
              optionValue="value"
              onChange={this.handlePeriodoChange}
            />
          </div>
        </div>

        <div className="filter-bar__right" onKeyDown={this.handleFilterKeyDown}>
          <div className="filter-bar__calendar-container">
            <div className="filter-bar__periodo-range-tablet">
              <p className="filter-bar__range-label">{t('PORTAL.FILTER.PERIOD')}</p>
              <Dropdown
                className="filter-bar__range-dropdown"
                value={this.state.periodoSelecionado}
                options={periodoOptions}
                optionLabel="label"
                optionValue="value"
                onChange={this.handlePeriodoChange}
              />
            </div>

            <div className="filter-bar__calendar">
              <p className="filter-bar__calendar-label">{t('PORTAL.FILTER.START_DATE')}</p>
              <Calendar
                className={`filter-bar__calendar-input ${this.state.dataInicialInvalida ? 'filter-bar__calendar--invalid' : ''}`}
                value={this.state.dataInicial}
                onChange={this.handleDataInicialChange}
              />
            </div>

            <div className="filter-bar__calendar">
              <p className="filter-bar__calendar-label">{t('PORTAL.FILTER.END_DATE')}</p>
              <Calendar
                className={`filter-bar__calendar-input ${this.state.dataFinalInvalida ? 'filter-bar__calendar--invalid' : ''}`}
                value={this.state.dataFinal}
                onChange={this.handleDataFinalChange}
              />
            </div>
          </div>

          <div className="filter-bar__actions">
            <div className="filter-bar__externos">
              <p className="filter-bar__externos-label">{t('PORTAL.FILTER.INCLUDED_EXAMS')}</p>

              <InputSwitch
                className={'filter-bar__externos-switch'}
                checked={this.state.pesquisarExamesExternos}
                onChange={this.handlePesquisarExamesExternos}
              />
            </div>

            <div className="filter-bar__clear">
              <Button
                className="filter-bar__button--clear"
                label={
                  <span className="filter-bar__button--clear-label">
                    <span
                      className={`filter-bar__icon--rotating ${this.state.girando ? 'rotating' : ''}`}
                    />
                    {t('PORTAL.BUTTON.CLEAR')}
                  </span>
                }
                onClick={() => {
                  this.setState(
                    {
                      dataInicialInvalida: false,
                      dataFinalInvalida: false,
                      nomeExame: '',
                      modalidadeSelecionada: 'todas',
                      periodoSelecionado: 'ultimos30',
                      dataInicial: (() => {
                        const date = new Date();
                        date.setDate(date.getDate() - 30);
                        return date;
                      })(),
                      dataFinal: new Date(),
                      usarRangeDataPaciente:
                        this.state.pesquisa_Inicial_Exames_Paciente === 'Filtro',
                      girando: true,
                    },
                    () => {
                      // chama o buscar logo após resetar tudo
                      this.handleBuscarClick();
                    }
                  );

                  setTimeout(() => this.setState({ girando: false }), 600);
                }}
              />
            </div>

            <div className="filter-bar__search-button-container">
              <Button label={t('PORTAL.BUTTON.SEARCH')} onClick={this.handleBuscarClick} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHeaderTopInfo() {
    const { t } = this.props;
    const isAcessoCompartilhado = this.state.isAcessoCompartilhado;

    const { isMedico, isExecutante, isConvenio } = this.state;

    const isPerfilMedico = isMedico || isExecutante;

    return (
      <div className="results-header">
        <div className="results-header__title">
          <span id="perfil"> </span>

          <p>{t('APP.MENU.EXAMES')}</p>
        </div>

        <div className="results-header__actions">
          {/*<div style={{ display: this.state.isMedico ? "none" : "block" }}>*/}

          {this.RetPerfil() !== 'Convênio' &&
            !isAcessoCompartilhado &&
            (isPerfilMedico
              ? this.state.botaoIncluirExamesAtivoMedico
              : this.state.botaoIncluirExamesAtivoPaciente) && (
              <Button
                label={
                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span className="icon-anexos" />
                    {t('PORTAL.BUTTON.INCLUDE_EXAMS')}
                  </span>
                }
                className="results-header__button--external-exam"
                onClick={() => this.handleAbrirModalExamesExternos('Exames externos')}
              />
            )}

          {/*</div>*/}

          {!isAcessoCompartilhado && (
            <div className="results-header__sort">{this.FiltroDropdown()}</div>
          )}

          {!isAcessoCompartilhado && (
            <div className="results-header__toggle-filters">
              <Button
                aria-label={t('PORTAL.FILTER.SORT')}
                onClick={this.toggleFiltro}
                className={`p-button ${this.state.mostrarFiltro ? 'ativo' : ''}`}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  renderHeaderLista() {
    //if (this.state.isMedico || ServiceLogin.isConvenio()) {
    //    return (
    //        <div className="filtroForm">
    //            <ComponentsPedidoFiltroForm
    //                mobilecheck={this.mobilecheck}
    //                onSortChange={this.onSortChange}
    //                sortKey={this.state.sortKey}
    //                onChangeDataViewLayoutOptions={value => this.onChangeDataViewLayoutOptions(value)}
    //                layout={this.state.layout}
    //                filtro={this.pedidoFiltro}
    //                onExecute={this.onExecuteFiltro.bind(this)}
    //                style={{ width: "100%" }}
    //            />
    //        </div>
    //    );
    //}
  }

  renderHeaderAnexoDiagnostico() {
    return (
      <div>
        <div>
          <span>{this.props.t('PORTAL.MODAL.DIAGNOSTIC_ATTACHMENT')}</span>
        </div>
        <Button
          icon="pi pi-times"
          onClick={e => this.setState({ panelAnexoVisible: false })}
          style={{
            position: 'absolute',
            float: 'right',
            right: '22px',
            marginTop: '-25px',
          }}
        />
      </div>
    );
  }

  renderPainelAnexoDiagnostico() {
    if (this.state.panelAnexoVisible) {
      const caminho = `${this.state.caminhoServico}api/Anexo/GetAnexoPortal/${this.state.selectedPedido.Id}`;
      const embed = `<embed src="${caminho}" width="100%" height="100%" />`;
      return (
        <div className={this.state.panelAnexoVisible ? 'p-col-7' : ''}>
          <Panel
            header={this.renderHeaderAnexoDiagnostico()}
            style={
              this.state.panelAnexoVisible ? { visibility: 'visible' } : { visibility: 'hidden' }
            }>
            <div>
              <ComponentEmbed embed={embed} id={this.state.selectedPedido.IdExterno} />
            </div>
          </Panel>
        </div>
      );
    } else return null;
  }

  renderFooter(name) {
    const { t } = this.props;
    return (
      <div>
        <Button
          label={t('PORTAL.BUTTON.YES')}
          icon="pi pi-check"
          onClick={() => {
            this.confirmaImprimirLaudo(true);
            this.onHide(name);
          }}
          autoFocus
        />
        <Button
          label={t('PORTAL.BUTTON.NO')}
          icon="pi pi-times"
          onClick={() => {
            this.confirmaImprimirLaudo(false);
            this.onHide(name);
          }}
          className="p-button-text"
        />
      </div>
    );
  }

  renderFooterCancelar(name) {
    const { t } = this.props;
    return (
      <div>
        <Button
          label={t('PORTAL.BUTTON.CANCEL')}
          icon="pi pi-times"
          onClick={() => {
            this.onHide(name);
          }}
          className="p-button-text"
        />
      </div>
    );
  }

  dataEstudoImagemVinculada(rowData) {
    const date = new Date(rowData.DataEstudo);
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };
    const formattedDate = date.toLocaleString([], options);

    return (
      <>
        <span className="p-column-title">{this.props.t('PORTAL.CARD.DATE')}</span>
        {formattedDate}
      </>
    );
  }

  idLaudoImagemVinculada(rowData) {
    return (
      <>
        <span className="p-column-title">ID</span>
        {rowData.Id}
      </>
    );
  }

  procedimentoImagemVinculada(rowData) {
    return (
      <>
        <span className="p-column-title">{this.props.t('PORTAL.FILTER.PROCEDURE')}</span>
        {rowData.ProcedimentoNome}
      </>
    );
  }

  modalidadeImagemVinculada(rowData) {
    return (
      <>
        <span className="p-column-title">{this.props.t('PORTAL.FILTER.MODALITY')}</span>
        {rowData.ModalidadeNome}
      </>
    );
  }

  botaoVisualizarImagemVinculada = rowData => {
    const abreImagemDoPedidoSelecionado = () => {
      let _viewer = rowData.VisualizadorPortal.replace('{STUDYUID}', rowData.StudyUid);
      _viewer = _viewer.replace('{STUDYID}', rowData.StudyId);

      const embedRemove = document.getElementsByTagName('embed');

      if (embedRemove.length > 0) {
        for (let index = 0; index < embedRemove.length; index++) embedRemove[index].remove();
      }

      let pedido = rowData;
      pedido.Modalidade = { Nome: rowData.ModalidadeNome };
      pedido.Procedimento = { Nome: rowData.ProcedimentoNome };
      pedido.MedicoExecutante = this.state.pedidoComImagemVinculadaMedicoExecutante;
      pedido.MedicoRevisor = this.state.pedidoComImagemVinculadaMedicoRevisor;
      pedido.Id = this.state.pedidoComImagemVinculadaId;
      this.handleAbrirImagem(pedido);
    };

    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          label={this.props.t('PORTAL.BUTTON.VIEW')}
          icon="pi pi-eye"
          onClick={abreImagemDoPedidoSelecionado}></Button>
      </div>
    );
  };

  renderHeaderAnexoDiagnostico() {
    return (
      <div>
        {' '}
        <i className="pi pi-paperclip"></i> {this.props.t('PORTAL.CARD.ATTACHMENTS')}{' '}
      </div>
    );
  }

  renderFooterAnexo(name) {
    return (
      <div>
        <Button
          label={this.props.t('PORTAL.BUTTON.CLOSE')}
          icon="pi pi-times"
          onClick={() => this.onHide(name)}
          className="p-button-text"
        />
      </div>
    );
  }

  nomeArquivoAnexoMob(rowData) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={require('./../images/pdf.png')}
          style={{ width: '24px', height: '24px', marginRight: '5px' }}
        />
        <span style={{ marginTop: '7px' }}>
          {rowData.Nome.slice(0, 15) + (rowData.Nome.length > 15 ? '...' : '')}
        </span>
        <div
          className={`anexo status-${rowData.TipoAnexo}`}
          style={{ padding: '5px', textAlign: 'center', marginLeft: '5px', fontSize: '10px' }}>
          {this.getAttachmentTypeLabel(rowData.TipoAnexo)}
        </div>
      </div>
    );
  }

  nomeArquivoAnexo(rowData) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={require('./../images/Icons/icone-pdf-azul.svg')}
          style={{ width: '24px', height: '24px', marginRight: '5px' }}
        />
        <span style={{ marginTop: '7px' }}>{rowData.Nome}</span>
      </div>
    );
  }

  statusTipoAnexo = rowData => {
    const _tipoAnexo = this.getAttachmentTypeLabel(rowData.TipoAnexo);

    return (
      <div style={{ textAlign: 'center' }}>
        <div className={`anexo status-${rowData.TipoAnexo}`}>{_tipoAnexo}</div>
      </div>
    );
  };

  statusPrioridade = rowData => {
    const prioridadeTexto = rowData.Prioridade || this.props.t('PORTAL.PRIORITY.NONE');
    const prioridadeClass = prioridadeTexto
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return (
      <div style={{ textAlign: 'center' }}>
        <div className={`parecerStatus status-${prioridadeClass}`}>{prioridadeTexto}</div>
      </div>
    );
  };

  async visualizarAnexo(rowData) {
    try {
      const url = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      if (isIOS) {
        // Abre direto — Safari mostrará o PDF/arquivo e o usuário pode "Salvar em Arquivos"
        this.downloadAnexo(rowData);
        return;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: ServiceApi._getHeaders().headers,
      });

      if (!response.ok) {
        throw new Error('Erro ao buscar anexo');
      }

      const contentType = response.headers.get('Content-Type') || 'application/octet-stream';

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);

      if (contentType.startsWith('application/pdf') || contentType.startsWith('image/')) {
        window.open(fileURL, '_blank');
      } else {
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = rowData.Nome || 'arquivo';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      let operacao = rowData.TipoAnexo === 1 ? 36 : 34;
      this.AdicionarHistoricoAcoes(
        operacao,
        this.state.selectedPedido.Id,
        this.state.selectedPedido.Tipo
      );
    } catch (error) {
      console.error('Erro ao visualizar anexo:', error);
    }
  }

  async downloadAnexo(anexo) {
    try {
      const url = `${this.state.caminhoServico}api/Anexo/GetAnexo/${anexo.Id}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: ServiceApi._getHeaders().headers,
      });

      if (!response.ok) throw new Error('Erro ao baixar o anexo');

      const data = await response.blob();

      const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
      const file = new Blob([data], { type: contentType });

      const fileName = anexo.Nome.replace(anexo.TipoArquivo, '') + anexo.TipoArquivo;

      const fileURL = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // libera memória depois de 10s
      setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
    } catch (error) {
      alert(this.props.t('PORTAL.MESSAGE.ATTACHMENT_DOWNLOAD_ERROR'));
      console.error(error);
    }
  }

  async iphoneDownloadWarning() {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      alert(this.props.t('PORTAL.MESSAGE.IOS_DOWNLOAD_HINT'));
    }
  }

  btnAnexoAcoes(pedido, rowData) {
    const isStl = rowData?.Nome?.toLowerCase().endsWith('.stl');

    if (isStl) {
      return (
        <div style={{ textAlign: 'center', display: 'flex' }}>
          <Button
            label=""
            onClick={() => this.visualizarAnexoStl(pedido)}
            className="buttonAnexoView"
            style={{ marginRight: '5px' }}
          />
        </div>
      );
    }

    return (
      <div style={{ textAlign: 'center', display: 'flex' }}>
        <Button
          label=""
          onClick={() => this.visualizarAnexo(rowData)}
          className="buttonAnexoView"
          style={{ marginRight: '5px' }}
        />
        <Button
          label=""
          onClick={() => {
            this.iphoneDownloadWarning();
            this.downloadAnexo(rowData);
          }}
          className="buttonAnexoDownload"
        />
      </div>
    );
  }

  tamanhoArquivoKB(rowData) {
    // Se já tiver o tamanho salvo, usa ele
    if (rowData.tamanhoKB) {
      return <span style={{ marginLeft: '10px' }}>{rowData.tamanhoKB.toFixed(0)} KB</span>;
    }

    // Se ainda não tiver, tenta buscar e salvar o tamanho
    if (!rowData._fetchingSize) {
      rowData._fetchingSize = true; // evita chamadas duplicadas

      const downloadUrl = `${this.state.caminhoServico}api/Anexo/GetAnexo/${rowData.Id}`;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', downloadUrl, true);
      xhr.responseType = 'blob';

      // 👇 Insere os headers de autenticação igual ao outro método
      const headers = ServiceApi._getHeaders().headers;
      xhr.setRequestHeader('user', headers.user);
      xhr.setRequestHeader('Cnonce', headers.Cnonce);
      xhr.setRequestHeader('Token', headers.Token);
      xhr.setRequestHeader('TokenPortal', headers.TokenPortal);
      xhr.setRequestHeader('isPacientePortal', headers.isPacientePortal);
      xhr.setRequestHeader('isConvenioPortal', headers.isConvenioPortal);

      xhr.onload = function () {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const tamanhoKB = blob.size / 1024;

          // Atualiza diretamente o objeto da linha com o tamanho
          rowData.tamanhoKB = tamanhoKB;

          // Força re-render da tabela
          this.setState({ listaAnexos: [...this.state.listaAnexos] });
        } else {
          console.error('Erro ao buscar tamanho do anexo:', xhr.status);
        }
      }.bind(this);

      xhr.onerror = function () {
        console.error('Erro de rede ao buscar tamanho do anexo.');
      };

      xhr.send();
    }

    return <span> </span>;
  }

  btnAnexoAcoesMob(rowData) {
    return (
      <div
        style={{
          textAlign: 'center',
          display: 'grid',
          gridTemplateRows: 'auto auto',
          rowGap: '5px',
        }}>
        <Button
          label=""
          tooltip={this.props.t('PORTAL.BUTTON.VIEW')}
          onClick={() => this.visualizarAnexo(rowData)}
          icon="custom-icon"
          className="p-button p-button-secondary"
          style={{ marginRight: '5px' }}
        />
        <Button
          label=""
          tooltip={this.props.t('PORTAL.BUTTON.DOWNLOAD')}
          onClick={() => this.downloadAnexo(rowData)}
          icon="custom-icon"
          className="p-button p-button-secondary"
        />
      </div>
    );
  }

  isPortalPaciente = () => {
    let perfil = sessionStorage.getItem('perfil');
    if (perfil) {
      perfil = perfil.toLowerCase();
      return perfil === 'paciente';
    }

    try {
      const auth = JSON.parse(sessionStorage.getItem('auth'));
      return auth?.TipoMedico === null || auth?.TipoMedico === undefined;
    } catch (error) {
      return false;
    }
  };

  buildViewerUrl = pedido => {
    const viewerTemplate = pedido?.Unidade?.VisualizadorPortal || pedido?.VisualizadorPortal || '';
    let _viewer = viewerTemplate
      .replace('{STUDYUID}', pedido?.StudyUid || '')
      .replace('{STUDYID}', pedido?.StudyId || '');

    const accessKey = getViewerAccessKey() || '';
    const validLangs = ['pt-BR', 'en-US', 'es-CL'];
    const appLang = localStorage.getItem('appLang') || i18n.language;
    const lang = appLang && validLangs.indexOf(appLang) !== -1 ? appLang : 'pt-BR';
    const fallback = lang === 'pt-BR' ? 'en-US' : 'pt-BR';
    const acceptLanguage = `${lang},en;q=0.9,${fallback};q=0.8`;

    let viewerUrl;
    try {
      viewerUrl = new URL(_viewer);
    } catch (error) {
      viewerUrl = new URL(_viewer, window.location.origin);
    }

    const studyInstanceUIDs =
      pedido?.StudyUid || viewerUrl.searchParams.get('StudyInstanceUIDs') || '';
    viewerUrl.pathname = '/study';
    viewerUrl.search = '';
    viewerUrl.searchParams.set('StudyInstanceUIDs', studyInstanceUIDs);
    viewerUrl.searchParams.set('accessKey', accessKey);
    viewerUrl.searchParams.set('language', lang);
    viewerUrl.searchParams.set('Accept-Language', acceptLanguage);
    if (this.isPortalPaciente()) viewerUrl.searchParams.set('isPacientePortal', true);
    return viewerUrl.toString();
  };

  renderZipandoDicom() {
    return (
      <Dialog
        className="processing-modal--zip"
        header={this.props.t('PORTAL.MODAL.COMPACTING_DICOM')}
        visible={this.state.zipandoDicom}
        modal
        closable={false}>
        <div>
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2em', marginBottom: '20px' }} />
          <p>{this.props.t('PORTAL.MODAL.COMPACTING_DICOM_DESCRIPTION')}</p>
        </div>
      </Dialog>
    );
  }

  renderResultadoInclusao() {
    const { resultadoInclusaoVisivel, resultadoInclusaoMensagem, resultadoInclusaoTipo } =
      this.state;
    const { t } = this.props;

    return (
      <Dialog
        header={t('PORTAL.MODAL.EXAM_INCLUSION')}
        visible={resultadoInclusaoVisivel}
        modal
        closable={false}
        className="action-feedback-modal--inclusion"
        footer={
          <div>
            {resultadoInclusaoTipo !== 'carregando' && (
              <Button
                label={t('COMMON.BUTTON.OK')}
                className={
                  resultadoInclusaoTipo === 'erro' ? 'p-button-danger' : 'p-button-success'
                }
                onClick={() => {
                  this.setState({ resultadoInclusaoVisivel: false }, () => {
                    this.componentDidMount();
                  });
                }}
              />
            )}
          </div>
        }>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {resultadoInclusaoTipo === 'carregando' ? (
            <>
              <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
              <p style={{ marginTop: '10px' }}>{resultadoInclusaoMensagem}</p>
            </>
          ) : (
            <p>{resultadoInclusaoMensagem}</p>
          )}
        </div>
      </Dialog>
    );
  }

  headerTemplate = options => {
    const { className, chooseButton, uploadButton, cancelButton, element } = options;

    return (
      <div className={className} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {chooseButton}
        {uploadButton}
        {cancelButton}

        <Button
          type="button"
          label={this.props.t('PORTAL.BUTTON.TAKE_PHOTO')}
          icon="pi pi-camera"
          className="p-button-secondary BotaoCamera"
          onClick={() => this.cameraInputRef && this.cameraInputRef.click()}
        />

        <input
          ref={el => (this.cameraInputRef = el)}
          type="file"
          accept="image/*"
          capture="environment"
          style={{ display: 'none' }}
          onChange={e => {
            const files = e.target.files;
            if (files && files.length > 0) {
              const fileList = Array.from(files);

              // Cria objeto de evento semelhante ao onSelect
              this.handleArquivoSelecionado({ files: fileList });

              // limpa o input pra nova foto
              e.target.value = '';
            }
          }}
        />

        {element}
      </div>
    );
  };

  renderAcoesDaModal = pedido => {
    return <StudyContentModal parent={this} pedido={pedido} mode="actions" />;
  };

  abrirViewer = pedido => {
    if (!pedido) return;

    if (this.mobilecheck && this.mobilecheck()) {
      // comportamento mobile: nova aba
      window.open(this.buildViewerUrl(pedido), 'imageFrame');
    } else {
      // desktop: mostra no iframe da modal
      const url = this.buildViewerUrl(pedido);
      this.setState({ viewerSrc: url });
    }
  };

  renderConteudoModalGenerica() {
    return <StudyContentModal parent={this} mode="content" />;
  }

  //#endregion

  //#region RENDER PRINCIPAL
  render() {
    const { t } = this.props;
    const headerLista = this.renderHeaderLista();

    const pedidoAtual = this.state.pedidoModalOpcoes;

    this.state.existeAnexo = this.DesabilitarBtnAnexo(pedidoAtual);

    const { isMedico, isExecutante, isConvenio } = this.state;

    const isPerfilMedico = isMedico || isExecutante;

    const prioridadeSelectItems = [
      { label: t('PORTAL.PRIORITY.NONE'), value: 0 },
      { label: t('PORTAL.PRIORITY.LOW'), value: 1 },
      { label: t('PORTAL.PRIORITY.MEDIUM'), value: 2 },
      { label: t('PORTAL.PRIORITY.HIGH'), value: 3 },
    ];

    // Ajusta composição do paginador:

    const { first, rows, totalPedidos, isMobile } = this.state;

    const PAGE_LINK_SIZE = 5; // precisa bater com o pageLinkSize do <Paginator> abaixo

    // Mostra "... [última página]" para permitir ir direto ao fim, no mesmo estilo
    // dos botões numéricos (.p-paginator-page) -- some quando a última página já
    // aparece entre os números visíveis ou quando já se está nela.
    const renderUltimaPaginaLink = (options, comPageLinks) => {
      if (options.disabled) return null;

      const { page, totalPages } = options.props;

      if (comPageLinks) {
        const visiblePages = Math.min(PAGE_LINK_SIZE, totalPages);
        const start = Math.max(0, Math.ceil(page - visiblePages / 2));
        const end = Math.min(totalPages - 1, start + visiblePages - 1);
        if (end === totalPages - 1) return null;
      }

      return (
        <span
          className="Paginador-UltimaPagina"
          style={{ display: 'inline-flex', alignItems: 'center' }}>
          <span className="Paginador-UltimaPagina-Reticencias" style={{ margin: '0 0.143rem' }}>
            ...
          </span>
          <span className="p-paginator-pages">
            <button
              type="button"
              className="p-paginator-page p-paginator-element p-link"
              onClick={options.onClick}>
              {totalPages}
            </button>
          </span>
        </span>
      );
    };

    // Mostra "[1] ..." para ir direto pro início, à direita do PrevPageLink --
    // some quando a página 1 já aparece entre os números visíveis ou quando já se está nela.
    const renderPrimeiraPaginaLink = (options, comPageLinks) => {
      if (options.disabled) return null;

      const { page, totalPages } = options.props;

      if (comPageLinks) {
        const visiblePages = Math.min(PAGE_LINK_SIZE, totalPages);
        const start = Math.max(0, Math.ceil(page - visiblePages / 2));
        if (start === 0) return null;
      }

      return (
        <span
          className="Paginador-PrimeiraPagina"
          style={{ display: 'inline-flex', alignItems: 'center' }}>
          <span className="p-paginator-pages">
            <button
              type="button"
              className="p-paginator-page p-paginator-element p-link"
              onClick={options.onClick}>
              1
            </button>
          </span>
          <span className="Paginador-PrimeiraPagina-Reticencias" style={{ margin: '0 0.143rem' }}>
            ...
          </span>
        </span>
      );
    };

    const desktopTemplate = {
      layout: 'PrevPageLink FirstPageLink PageLinks LastPageLink NextPageLink',
      FirstPageLink: options => renderPrimeiraPaginaLink(options, true),
      LastPageLink: options => renderUltimaPaginaLink(options, true),
    };
    const mobileTemplate = {
      layout: 'PrevPageLink FirstPageLink CurrentPageReport LastPageLink NextPageLink',
      FirstPageLink: options => renderPrimeiraPaginaLink(options, false),
      LastPageLink: options => renderUltimaPaginaLink(options, false),
    };

    return (
      <div>
        <ModalMensagem
          visible={this.state.modalErroVisivel}
          onHide={() => this.setState({ modalErroVisivel: false })}
          tipo="erro"
          mensagem={this.state.mensagemErro}
          imagem={imgErro}
        />

        {this.renderHeaderFilter()}

        {this.renderHeaderTopInfo()}

        {this.renderZipandoDicom()}

        {this.renderResultadoInclusao()}

        <div className="main-body">
          <div className="layout-main">
            <Dialog
              className="modal-confirmar-impressao"
              header={t('PORTAL.MODAL.CONFIRM_PRINT')}
              position="top"
              visible={this.state.modalConfirmaImpressao}
              footer={this.renderFooter('modalConfirmaImpressao')}
              onHide={() => this.onHide('modalConfirmaImpressao')}>
              <p className="modal-confirmar-impressao--text">
                {t('PORTAL.MODAL.PRINT_DIAGNOSTIC_ATTACHMENT')}
              </p>
            </Dialog>

            <Dialog
              header={t('PORTAL.MODAL.NOTICE')}
              position="top"
              visible={this.state.modalImagemOutroPedido}
              style={{ width: this.mobilecheck() ? '90vw' : '70vw' }}
              footer={this.renderFooterCancelar('modalImagemOutroPedido')}
              onHide={() => this.onHide('modalImagemOutroPedido')}>
              <p style={{ fontSize: '16px', marginTop: '.5rem', fontWeight: 'bold' }}>
                {t('PORTAL.MODAL.IMAGE_SAME_PATIENT_WARNING')}
              </p>
              <div className="datatable-responsive-demo">
                <div className="card">
                  <DataTable
                    value={this.state.imagensVinculadas}
                    className="p-datatable-gridlines p-datatable-responsive-demo">
                    <Column
                      field="Visualizar"
                      header=" "
                      body={this.botaoVisualizarImagemVinculada.bind(this)}
                    />
                    <Column
                      field="Laudo"
                      header={t('PORTAL.CARD.REPORT')}
                      body={this.idLaudoImagemVinculada}
                    />
                    <Column
                      field="Data do Estudo"
                      header={t('PORTAL.MODAL.STUDY_DATE')}
                      body={this.dataEstudoImagemVinculada}
                    />
                    <Column
                      field="Procedimento"
                      header={t('PORTAL.FILTER.PROCEDURE')}
                      body={this.procedimentoImagemVinculada}
                    />
                    <Column
                      field="Modalidade"
                      header={t('PORTAL.FILTER.MODALITY')}
                      body={this.modalidadeImagemVinculada}
                    />
                  </DataTable>
                </div>
              </div>
            </Dialog>

            <Dialog
              header={this.renderHeaderAnexoDiagnostico()}
              visible={this.state.modalAnexo}
              style={{ width: this.mobilecheck() ? '100%' : '50vw' }}
              footer={this.renderFooterAnexo('modalAnexo')}
              onHide={() => this.onHide('modalAnexo')}>
              <div className="card" style={{ display: this.mobilecheck() ? 'none' : 'block' }}>
                <DataTable value={this.state.listaAnexos} className="p-datatable-gridlines">
                  <Column
                    field="Nome"
                    header={t('PORTAL.MODAL.NAME')}
                    body={this.nomeArquivoAnexo}></Column>
                  <Column
                    field="TipoAnexo"
                    header={t('PORTAL.MODAL.TYPE')}
                    body={this.statusTipoAnexo}
                    headerStyle={{ width: '9em' }}></Column>
                  <Column
                    field=""
                    header={t('PORTAL.MODAL.ACTIONS')}
                    headerStyle={{ width: '9em' }}
                    body={e => this.btnAnexoAcoes(e)}></Column>
                </DataTable>
              </div>

              <div style={{ display: this.mobilecheck() ? 'block' : 'none' }}>
                <DataTable value={this.state.listaAnexos} className="p-datatable-gridlines">
                  <Column
                    field="Nome"
                    header={t('PORTAL.MODAL.NAME')}
                    body={this.nomeArquivoAnexoMob}></Column>
                  <Column
                    style={{ width: '70px' }}
                    field=""
                    header={t('PORTAL.MODAL.ACTIONS')}
                    body={e => this.btnAnexoAcoesMob(e)}></Column>
                </DataTable>
              </div>
            </Dialog>

            <Dialog
              header={t('PORTAL.MODAL.DOWNLOAD_IN_PROGRESS')}
              visible={this.state.dialogDicomZip}
              modal
              style={{ width: '350px' }}
              closable={false}
              className="download-dicom-zip--modal">
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                <p style={{ marginTop: '15px' }}>
                  {this.state.progressoDicomZip === 0
                    ? t('PORTAL.MODAL.PREPARING_FILE')
                    : `${t('PORTAL.MODAL.DOWNLOADING_FILE')} ${this.state.progressoDicomZip}kb`}
                </p>
              </div>
            </Dialog>

            <Dialog
              header={t('PORTAL.MODAL.EXAM_INCLUSION')}
              visible={this.state.modalExamesExternosVisivel}
              className="external-exams-modal"
              modal
              onHide={() => this.setState({ modalExamesExternosVisivel: false })}>
              <div className="external-exams-modal__wrapper">
                <div className="external-exams-modal__content">
                  <div className="external-exams-modal__form-group">
                    <div className="external-exams-modal__field">
                      <span className="external-exams-modal__label">
                        {t('PORTAL.MODAL.EXAM_DESCRIPTION')}
                      </span>
                      <AutoComplete
                        className={`external-exams-modal__autocomplete ${this.state.erroDescricao ? 'campo-obrigatorio' : ''}`}
                        panelClassName="external-exams-modal__autocomplete-panel"
                        value={this.state.descricaoExame}
                        suggestions={this.state.procedimentosSugeridos}
                        completeMethod={this.buscarProcedimentos}
                        minLength={2}
                        field="Nome"
                        placeholder={t('PORTAL.MODAL.TYPE_TO_SEARCH')}
                        // Se disponível na sua versão, isso já ajuda muito:
                        // forceSelection
                        onChange={e => {
                          const novoValor = e.value || '';
                          this.setState(prev => ({
                            descricaoExame: novoValor,
                            // EDITAR o texto invalida a seleção anterior
                            procedimentoSelecionado:
                              typeof novoValor === 'string' ? null : prev.procedimentoSelecionado,
                          }));
                        }}
                        onSelect={e => {
                          // e.value é o objeto selecionado da lista
                          this.setState({
                            procedimentoSelecionado: e.value,
                            descricaoExame: e.value?.Nome || '',
                          });
                        }}
                        onBlur={() => {
                          const { descricaoExame, procedimentoSelecionado } = this.state;
                          const valido =
                            !!procedimentoSelecionado &&
                            descricaoExame === procedimentoSelecionado.Nome;
                          if (!valido) {
                            this.setState({ procedimentoSelecionado: null, erroDescricao: true });
                            // Opcional: limpar o texto para deixar explícito que não é válido
                            this.setState({ descricaoExame: '' });
                          } else {
                            this.setState({ erroDescricao: false });
                          }
                        }}
                      />
                    </div>

                    <div className="external-exams-modal__field">
                      <span className="external-exams-modal__label">
                        {t('PORTAL.MODAL.EXAM_CLINIC_HOSPITAL')}
                      </span>

                      <InputText
                        className={`external-exams-modal__input ${this.state.erroLocal ? 'campo-obrigatorio' : ''}`}
                        value={this.state.localExameExterno}
                        onChange={e => this.setState({ localExameExterno: e.target.value })}
                      />
                    </div>
                  </div>

                  <div className="external-exams-modal__form-group">
                    <div className="external-exams-modal__field">
                      <span className="external-exams-modal__label">
                        {t('PORTAL.MODAL.EXAM_DATE')}
                      </span>

                      <Calendar
                        className={`external-exams-modal__calendar ${this.state.erroData ? 'campo-obrigatorio' : ''}`}
                        value={this.state.dataExameExterno}
                        maxDate={new Date()} // ⬅️ impede datas futuras
                        onChange={e => this.setState({ dataExameExterno: e.value })}
                      />
                    </div>

                    <div className="external-exams-modal__field">
                      <span className="external-exams-modal__label">
                        {t('PORTAL.MODAL.REQUESTING_DOCTOR_LABEL')}
                      </span>
                      <InputText
                        className="external-exams-modal__input"
                        value={this.state.medicoSolicitanteExameExterno}
                        onChange={e =>
                          this.setState({ medicoSolicitanteExameExterno: e.target.value })
                        }
                      />
                    </div>

                    <div className="external-exams-modal__field">
                      <span className="external-exams-modal__label">
                        {t('PORTAL.MODAL.REQUESTING_DOCTOR_CRM')}
                      </span>
                      <InputText
                        className="external-exams-modal__input"
                        value={this.state.crmMedicoSolicitanteExameExterno}
                        onChange={e =>
                          this.setState({ crmMedicoSolicitanteExameExterno: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  {this.state.erroCamposObrigatorios && (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '10px',
                        fontWeight: 'bold',
                        marginBottom: '30px',
                      }}>
                      {t('PORTAL.MODAL.REQUIRED_FIELDS')}
                    </div>
                  )}

                  <div className="external-exams-modal__upload">
                    <span className="external-exams-modal__label">
                      {t('PORTAL.MODAL.ATTACH_FILES')}
                    </span>

                    <div className="external-exams-modal__upload-buttons">
                      {/* Botões de seleção */}
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                        {/* Botão Selecionar Arquivos */}
                        <Button
                          label={t('PORTAL.BUTTON.SELECT_FILES')}
                          icon="pi pi-folder-open"
                          className="external-exams-modal__button--select-file"
                          onClick={() => this.inputArquivosRef && this.inputArquivosRef.click()}
                        />
                        <input
                          type="file"
                          ref={el => (this.inputArquivosRef = el)}
                          style={{ display: 'none' }}
                          accept=".pdf,.png,.jpg,.jpeg"
                          multiple
                          onChange={e => {
                            const files = Array.from(e.target.files);
                            this.adicionarArquivos(files);
                            e.target.value = ''; // limpa para permitir reseleção do mesmo arquivo
                          }}
                        />

                        {window.innerWidth < 1024 ? (
                          // Mobile: botão que abre a câmera nativa
                          <>
                            <Button
                              label={t('PORTAL.BUTTON.TAKE_PHOTO')}
                              icon="pi pi-camera"
                              className="external-exams-modal__button--camera"
                              onClick={() => this.inputCameraRef && this.inputCameraRef.click()}
                            />
                            <input
                              type="file"
                              ref={el => (this.inputCameraRef = el)}
                              style={{ display: 'none' }}
                              accept="image/*"
                              capture="environment"
                              onChange={e => {
                                const files = Array.from(e.target.files);
                                this.adicionarArquivos(files);
                                e.target.value = '';
                              }}
                            />
                          </>
                        ) : (
                          //Desktop: abre modal com CameraCapture
                          <>
                            <Button
                              label={t('PORTAL.BUTTON.TAKE_PHOTO')}
                              icon="pi pi-camera"
                              className="external-exams-modal__button--camera"
                              onClick={() => this.setState({ mostrarCamera: true })}
                            />
                            {this.state.mostrarCamera && (
                              <CameraCapture
                                onCapture={files => this.adicionarArquivos(files)}
                                onClose={() => this.setState({ mostrarCamera: false })}
                                preferredFacing="environment"
                                captureWidth={1280}
                                captureHeight={720}
                              />
                            )}
                          </>
                        )}
                      </div>

                      {/* Lista de arquivos em grid */}
                      {/* Lista de arquivos em lista vertical com scroll */}
                      <div className="external-exams-modal__upload-grid">
                        {this.state.arquivosSelecionados.length > 0 ? (
                          <ul className="arquivos-lista">
                            {this.state.arquivosSelecionados.map((arquivo, index) => (
                              <li
                                key={`${arquivo.name}-${arquivo.size}-${index}`}
                                className="arquivo-item">
                                <i className="pi pi-file arquivo-icone" aria-hidden />
                                <div className="arquivo-info">
                                  <div className="arquivo-nome" title={arquivo.name}>
                                    {arquivo.name}
                                  </div>
                                  <div className="arquivo-meta">
                                    {Math.ceil(arquivo.size / 1024)} KB
                                  </div>
                                </div>
                                <div className="arquivo-acoes">
                                  {/* Botão visualizar */}
                                  <Button
                                    icon="pi pi-eye"
                                    className="external-exams-modal__button-visualizer"
                                    style={{
                                      color: 'black',
                                      backgroundColor: 'transparent',
                                      boder: 'none',
                                    }}
                                    tooltip={t('PORTAL.BUTTON.VIEW')}
                                    onClick={() => this.visualizarArquivo(arquivo)}
                                  />

                                  {/* Botão remover */}
                                  <Button
                                    icon="pi pi-times"
                                    className="p-button-rounded p-button-danger p-button-sm"
                                    tooltip={t('PORTAL.BUTTON.REMOVE')}
                                    onClick={() => this.removerArquivo(index)}
                                  />
                                </div>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div className="grid-vazia">{t('PORTAL.MODAL.NO_FILES_SELECTED')}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  {this.state.habilitarEnvioDicomExamesExternos && (
                    <div className="external-exams-modal__dicom-section">
                      <span className="external-exams-modal__label">
                        {t('PORTAL.MODAL.DICOM_IMAGE_FOLDER')}
                      </span>
                      <div className="external-exams-modal__dicom-path-input">
                        <div className="external-exams-modal__dicom-input-row">
                          <InputText
                            className="external-exams-modal__input"
                            value={this.state.caminhopastaDicomExameExterno}
                            onChange={e =>
                              this.setState({ caminhopastaDicomExameExterno: e.target.value })
                            }
                            readOnly
                          />

                          <input
                            type="file"
                            ref={this.inputPastaRef}
                            style={{ display: 'none' }}
                            onChange={this.handleSelecionarPastaDicom}
                            webkitdirectory="true"
                            directory="true"
                            multiple
                          />
                        </div>

                        <div style={{ display: 'flex' }}>
                          {this.state.zipDicom && (
                            <Button
                              icon="pi pi-times"
                              className="p-button-text p-button-danger"
                              tooltip={t('PORTAL.MODAL.REMOVE_SELECTED_FOLDER')}
                              onClick={() => {
                                this.setState({
                                  zipDicom: null,
                                  caminhopastaDicomExameExterno: '',
                                });

                                // Reseta o input file para permitir nova seleção da mesma pasta
                                if (this.inputPastaRef.current) {
                                  this.inputPastaRef.current.value = null;
                                }
                              }}
                            />
                          )}

                          {!this.state.zipDicom && (
                            <Button
                              className="btnSelecionarDicomExterno"
                              label={t('PORTAL.BUTTON.SELECT_FILES')}
                              onClick={this.handleClickSelecionarPastaDicom}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div>
                    {this.state.erroArquivos && (
                      <div
                        className="Exames-externos-aviso"
                        style={{ color: 'red', marginTop: '10px', fontWeight: 'bold' }}>
                        {t('PORTAL.MODAL.FILES_REQUIRED')}
                      </div>
                    )}
                  </div>

                  <div className="external-exams-modal__actions">
                    <Dialog
                      header={t('PORTAL.MODAL.CONSENT_TERM')}
                      className="termo-consetimento-exame-externo"
                      visible={this.state.mostrarModalConsentimento}
                      style={{ width: '40vw' }}
                      modal
                      onHide={() => this.setState({ mostrarModalConsentimento: false })}>
                      <p className="exame-externo-termo-texto">
                        {t('PORTAL.MODAL.CONSENT_TEXT_1')}
                      </p>
                      <p className="exame-externo-termo-texto">
                        {t('PORTAL.MODAL.CONSENT_TEXT_2')}
                      </p>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: '1rem',
                          marginTop: '2rem',
                        }}>
                        <Button
                          label={t('PORTAL.BUTTON.CANCEL')}
                          className="p-button-text"
                          onClick={() => this.setState({ mostrarModalConsentimento: false })}
                        />
                        <Button
                          label={t('PORTAL.BUTTON.ACCEPT')}
                          className="p-button-success"
                          onClick={() => {
                            this.setState({ mostrarModalConsentimento: false }, () => {
                              this.handleIncluirExamesExternos();
                            });
                          }}
                        />
                      </div>
                    </Dialog>

                    <Button
                      className="external-exams-modal__button--submit"
                      label={t('PORTAL.BUTTON.INCLUDE')}
                      onClick={() => this.setState({ mostrarModalConsentimento: true })}
                    />

                    <Button
                      label={t('PORTAL.BUTTON.CANCEL')}
                      className="external-exams-modal__button--cancel"
                      onClick={() => {
                        this.setState({ modalExamesExternosVisivel: false });
                        this.setState({
                          descricaoExame: '',
                          dataExameExterno: '',
                          localExameExterno: '',
                          arquivosSelecionados: '',
                          medicoSolicitanteExameExterno: '',
                          crmMedicoSolicitanteExameExterno: '',
                          zipDicom: '',
                          pedidoModalOpcoes: '',
                          erroArquivos: false,
                          erroCamposObrigatorios: false,
                          erroDescricao: false,
                          erroLocal: false,
                          erroData: false,
                          caminhopastaDicomExameExterno: '',
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </Dialog>

            <div>
              <div className="p-col-12 p-lg-12">
                <div
                  className="content-section introduction"
                  style={{ display: this.state.isMedico ? 'none' : 'block' }}></div>

                {headerLista}

                <div id="gridListaPedidos" className="content-section implementation">
                  <div className="p-grid">
                    <div
                      className={
                        this.state.panelImageJpegVisible || this.state.panelAnexoVisible
                          ? 'p-col-5'
                          : 'p-col-12'
                      }
                      style={autoHeigthLista}>
                      <div>
                        {(this.state.pedidosCombinados?.length ?? 0) > 0 ? (
                          <DataView
                            value={this.state.pedidosCombinados}
                            layout={this.state.layout}
                            itemTemplate={pedido => this.itemTemplate(pedido, this.state.layout)}
                            paginator={false}
                            rows={this.state.rows}
                            emptyMessage={null}
                          />
                        ) : (
                          <div className="no-results">
                            <img
                              className="no-tesults--image"
                              src={require('../images/sem-resultados.svg')}
                              alt={t('PORTAL.MODAL.NO_RESULTS_ALT')}
                              style={{ width: 120, marginBottom: 20 }}
                            />
                            <h3>{t('PORTAL.MODAL.NO_EXAMS_FOUND_TITLE')}</h3>
                            <p>{t('PORTAL.MODAL.NO_EXAMS_FOUND_1')}</p>
                            <p>{t('PORTAL.MODAL.NO_EXAMS_FOUND_2')}</p>
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          height: this.state.mostrarFiltro ? '12%' : '5%',
                          opacity: this.state.mostrarFiltro ? 1 : 0.5,
                          transition: 'height 0.4s ease, opacity 0.4s ease',
                        }}></div>
                    </div>
                    {this.renderPainelAnexoDiagnostico(0)}
                  </div>
                  <Dialog
                    header={t('PORTAL.MODAL.ORDER_DETAILS')}
                    visible={this.state.visible}
                    modal={true}
                    onHide={() => this.setState({ visible: false })}>
                    {this.renderPedidoDialogContent()}
                  </Dialog>
                </div>
              </div>
            </div>

            <div className="Footer-bar">
              <div className="footer-bar--left">
                <div className="Paginador">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalPedidos}
                    onPageChange={this.onPageChange}
                    template={isMobile ? mobileTemplate : desktopTemplate}
                    pageLinkSize={PAGE_LINK_SIZE}
                    currentPageReportTemplate="{currentPage} de {totalPages}"
                    responsiveLayout="stack"
                  />
                </div>
              </div>
              <div className="footer-bar--right">
                <div className="Version-info">© 2025 Tzion MyResult 2026.002.01.01</div>
              </div>
            </div>

            <Sidebar
              header={t('PORTAL.MODAL.GALLERY')}
              blockScroll={true}
              fullScreen={true}
              visible={this.state.panelImageJpegVisible}
              modal={false}
              //onHide={() => this.setState({panelImageJpegVisible: false})}
              style={{ zIndex: '999', border: 'none', backgroundColor: '#000', padding: '0' }}
              showCloseIcon={false}>
              <GaleriaImagens
                selectedPedido={this.state.selectedPedido}
                servicoImagem={this.state.servicoImagemPortal}
                panelImageJpegMaximize={e => this.panelImageJpegMaximize()}
                handleFecharImagemJpg={e => this.handleFecharImagemJpg()}
                onHideGaleria={() => this.onHideGaleria()}
                mobilecheck={() => this.mobilecheck()}
                panelImageJpegVisible={this.state.panelImageJpegVisible}
                adicionarHistoricoAcoes={(acao, pedidoId) =>
                  this.AdicionarHistoricoAcoes(acao, pedidoId, this.state.pedidoModalOpcoes?.Tipo)
                }
              />
            </Sidebar>

            <Sidebar
              header={t('PORTAL.MODAL.SHARE_PORTAL_LINK')}
              blockScroll={true}
              position="bottom"
              visible={this.state.visibleDialog}
              modal={false}
              onHide={() => this.setState({ visibleDialog: false })}
              style={{ zIndex: '999', border: 'none', height: '200px' }}>
              <div className="tituloSlideForm">
                <i className="pi pi-share-alt"></i>{' '}
                <strong>{t('PORTAL.MODAL.SHARE_PORTAL_LINK')}</strong>
              </div>

              <br></br>

              <div
                style={{
                  display: 'grid',
                  gridTemplateRows: 'auto auto auto',
                  rowGap: '10px',
                  width: '100%',
                  position: 'fixed',
                  left: '0',
                  bottom: '0',
                  padding: '20px 10px 10px 10px',
                  backgroundColor: 'rgb(52, 51, 67)',
                  boxShadow: '0 0 10px 2px #ccc',
                }}>
                <div>
                  <div className=" ">
                    {this.tipoCompartilhamento.map(tipo => {
                      return (
                        <div
                          key={tipo.key}
                          className="p-field-radiobutton"
                          style={{ float: 'left', marginRight: '20px' }}>
                          <RadioButton
                            inputId={tipo.key}
                            name="tipo"
                            value={tipo}
                            onChange={e => this.setState({ selectedCompartilhamento: e.value })}
                            checked={this.state.selectedCompartilhamento.key === tipo.key}
                          />
                          <label htmlFor={tipo.key}>{tipo.name}</label>
                        </div>
                      );
                    })}
                  </div>

                  <br />
                  <br />
                  <InputMask
                    type="tel"
                    style={{
                      width: '100%',
                      display: this.state.selectedCompartilhamento.key === 0 ? 'block' : 'none',
                    }}
                    id="celular"
                    mask="(99)99999-9999"
                    value={this.state.celCompartilhar}
                    placeholder="(99)99999-9999"
                    onChange={e => this.setState({ celCompartilhar: e.value })}></InputMask>
                  <InputText
                    style={{
                      width: '100%',
                      display: this.state.selectedCompartilhamento.key === 1 ? 'block' : 'none',
                    }}
                    name="email"
                    placeholder={t('PORTAL.MESSAGE.VALID_EMAIL_REQUIRED')}
                    value={this.state.emailCompartilhar}
                    onChange={e => {
                      this.setState({ emailCompartilhar: e.target.value });
                    }}
                  />
                </div>

                <div>
                  <label>{t('PORTAL.MODAL.LINK_VALIDITY')}</label>
                  <br />
                  <Dropdown
                    style={{ borderColor: '#e3ebf6' }}
                    options={listPrazo}
                    placeholder={t('PORTAL.MODAL.SELECT_DEADLINE')}
                    value={this.state.prazoValue}
                    onChange={e => {
                      this.setState({ prazoValue: e.value });
                    }}
                  />
                </div>

                <div
                  style={{
                    textAlign: 'right',
                    borderTop: 'solid 1px #ccc',
                    marginTop: '10px',
                    paddingTop: '10px',
                  }}>
                  <Button
                    label={t('PORTAL.BUTTON.SHARE')}
                    className="p-button-info"
                    onClick={e => {
                      {
                        this.handleCompartilharLinkPortal();
                      }
                    }}
                    style={{ marginRight: '10px' }}
                  />
                  <Button
                    label={t('PORTAL.BUTTON.CANCEL')}
                    className="p-button-text"
                    onClick={e => this.setState({ visibleDialog: false })}
                  />
                </div>
              </div>
            </Sidebar>

            <Sidebar
              visible={this.state.visibleDialogComentario}
              fullScreen={true}
              blockScroll={true}
              modal={false}
              showCloseIcon={true}
              style={{ zIndex: '999', border: 'none' }}
              onHide={() => this.setState({ visibleDialogComentario: false })}>
              <div className="tituloSlideForm">
                <i className="pi pi-comment"></i>{' '}
                <strong>{t('PORTAL.MODAL.MEDICAL_OPINION')}</strong>
              </div>

              <br></br>

              <div
                className="card"
                style={{ padding: '0px', height: '70vw', borderBottom: 'solid 1px #ccc' }}>
                <DataTable
                  value={this.state.listaParecer}
                  header={t('PORTAL.MODAL.HISTORY')}
                  className="p-datatable-gridlines">
                  <Column field="DataCadastro" header={t('PORTAL.CARD.DATE')}></Column>
                  <Column field="Texto" header={t('PORTAL.MODAL.DESCRIPTION')}></Column>
                  <Column
                    field="Prioridade"
                    header={t('PORTAL.MODAL.PRIORITY')}
                    style={{ textAlign: 'center' }}></Column>
                </DataTable>
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateRows: 'auto auto auto',
                  rowGap: '10px',
                  width: '100%',
                  position: 'fixed',
                  left: '0',
                  bottom: '0',
                  padding: '20px 10px 10px 10px',
                  backgroundColor: 'rgb(52, 51, 67)',
                  boxShadow: '0 0 10px 2px #ccc',
                }}>
                <div>
                  <label className="textWhite">{t('PORTAL.MODAL.MEDICAL_OPINION_LABEL')} </label>
                  <InputTextarea
                    placeholder={t('PORTAL.MODAL.MEDICAL_OPINION_PLACEHOLDER')}
                    value={this.state.parecerTexto}
                    onChange={e => this.setState({ parecerTexto: e.target.value })}
                    autoResize={true}
                    style={{ width: '100%', height: '100px' }}
                  />
                </div>

                <div>
                  <label className="textWhite">{t('PORTAL.MODAL.PRIORITY')}: </label>
                  <Dropdown
                    value={this.state.parecerPrioridade}
                    options={prioridadeSelectItems}
                    onChange={e => {
                      this.setState({ parecerPrioridade: e.value });
                    }}
                  />
                </div>

                <div
                  style={{
                    textAlign: 'right',
                    borderTop: 'solid 1px #ccc',
                    marginTop: '10px',
                    paddingTop: '10px',
                  }}>
                  <Button
                    label={t('PORTAL.BUTTON.SAVE')}
                    onClick={e => {
                      {
                        this.handleSalvarParecer();
                      }
                    }}
                    style={{ marginRight: '10px' }}
                  />
                  <Button
                    label={t('PORTAL.BUTTON.CANCEL')}
                    className="p-button-text"
                    onClick={e => this.setState({ visibleDialogComentario: false })}
                  />
                </div>
              </div>
            </Sidebar>

            <ComponentsAppSplash visible={this.state.isLoading} />
          </div>

          <div style={{ width: '20px' }}></div>
        </div>

        <Dialog
          className={`StudyContentModal ModalGenerica ${this.getClasseVisualizador()}`}
          header={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                position: 'relative',
              }}>
              <div className="botao-acoes results-header__toggle-filters">
                <Button
                  className={`p-button ${this.state.mostrarModalAcoesMobile ? 'ativo' : ''}`}
                  onClick={() =>
                    this.setState({ mostrarModalAcoesMobile: !this.state.mostrarModalAcoesMobile })
                  }
                />
              </div>

              {/* Dropdown flutuante abaixo do botão */}
              {this.state.mostrarModalAcoesMobile && (
                <div className="DialogMobileAcoesDropdown">
                  <div className="ModalButtons">
                    <div>
                      {(isPerfilMedico
                        ? this.state.botaoGaleriaAtivoMedico
                        : this.state.botaoGaleriaAtivoPaciente) && (
                        <Button
                          label={
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span className="icon-galeria" />
                              {this.getConfiguredLabel(
                                this.state.labelBotaoGaleria,
                                'PORTAL.CARD.IMAGE_GALLERY',
                                [
                                  'Galeria',
                                  'Galeria de imagens',
                                  'Galeria de Imagens',
                                  'Abrir Galeria',
                                  'Abrir galeria',
                                  'Abrir galeria de imagens',
                                  'Abrir Galeria de Imagens',
                                  'Image gallery',
                                  'Image Gallery',
                                  'Open gallery',
                                  'Open Gallery',
                                  'Open image gallery',
                                  'Gallery',
                                  'Galería',
                                  'Galería de imágenes',
                                  'Galería de Imágenes',
                                  'Abrir galería',
                                  'Abrir galería de imágenes',
                                ]
                              )}
                            </span>
                          }
                          className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Galeria' ? 'buttom-modal-selected' : ''}`}
                          onClick={() =>
                            this.setState({
                              modalOpcaoSelecionada: 'Galeria',
                              mostrarModalAcoesMobile: false,
                            })
                          }
                        />
                      )}
                    </div>

                    {this.mostrarBotaoLaudoNaModal(this.state.pedidoModalOpcoes) && (
                      <div>
                        {(isPerfilMedico
                          ? this.state.botaoLaudoAtivoMedico
                          : this.state.botaoLaudoAtivoPaciente) && (
                          <Button
                            label={
                              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span className="icon-laudo" />
                                {this.state.labelBotaoLaudo || t('PORTAL.CARD.REPORT')}
                              </span>
                            }
                            className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Laudo' ? 'buttom-modal-selected' : ''}`}
                            onClick={() => {
                              this.setState({
                                modalOpcaoSelecionada: 'Laudo',
                                mostrarModalAcoesMobile: false,
                              });
                            }}
                          />
                        )}
                      </div>
                    )}

                    <div>
                      {(isPerfilMedico
                        ? this.state.botaoAnexosAtivoMedico
                        : this.state.botaoAnexosAtivoPaciente) && (
                        <Button
                          label={
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span className="icon-anexos" />
                              {this.state.labelBotaoAnexos || t('PORTAL.CARD.ATTACHMENTS')}
                            </span>
                          }
                          visible={!this.state.existeAnexo}
                          className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Anexos' ? 'buttom-modal-selected' : ''}`}
                          onClick={() =>
                            this.setState({
                              modalOpcaoSelecionada: 'Anexos',
                              mostrarModalAcoesMobile: false,
                            })
                          }
                        />
                      )}
                    </div>

                    <div
                      className="ModalButtons-executante"
                      style={{ display: this.state.isExecutante ? 'block' : 'none' }}>
                      {this.RetPerfil() === 'Médico Executante' && (
                        <div>
                          {this.state.botaoParecerAtivoMedico && (
                            <Button
                              label={
                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span className="icon-parecer" />
                                  {this.getConfiguredLabel(
                                    this.state.labelBotaoParecer,
                                    'PORTAL.CARD.MEDICAL_OPINION',
                                    [
                                      'Parecer médico',
                                      'Parecer Médico',
                                      'Visualizar Parecer',
                                      'Visualizar Parecer Médico',
                                    ]
                                  )}
                                </span>
                              }
                              className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Parecer' ? 'buttom-modal-selected' : ''}`}
                              onClick={() =>
                                this.setState({
                                  modalOpcaoSelecionada: 'Parecer',
                                  mostrarModalAcoesMobile: false,
                                })
                              }
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {this.renderAcoesDaModal(this.state.pedidoModalOpcoes)}
                </div>
              )}

              <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                {this.getModalOpcaoLabel(this.state.modalOpcaoSelecionada)}
              </span>
            </div>
          }
          visible={this.state.modalOpcoesVisivel}
          modal
          draggable={false}
          onHide={() => {
            document.body.style.overflow = 'auto';
            document.body.classList.remove('p-overflow-hidden', 'overflow-hidden');
            document.documentElement.style.overflow = 'auto';
            document.documentElement.classList.remove('p-overflow-hidden', 'overflow-hidden');

            this.setState({ modalOpcoesVisivel: false, mostrarModalAcoesMobile: false });
          }}>
          {this.state.pedidoModalOpcoes && (
            <div className="ModalPedido">
              {this.state.modalOpcaoSelecionada !== 'Viewer' && (
                <div className={`ModalNavegacao ${this.getClasseVisualizador()}`}>
                  {this.mostrarBotao(this.state.pedidoModalOpcoes) &&
                    this.state.modalOpcaoSelecionada !== 'Imagens' &&
                    this.state.modalOpcaoSelecionada !== 'Arquivos' && (
                      <div className="ModalButtons">
                        {(this.state.pedidoModalOpcoes.StudyUid ||
                        this.state.pedidoModalOpcoes.possuiJob
                          ? isPerfilMedico
                            ? this.state.botaoGaleriaAtivoMedico
                            : this.state.botaoGaleriaAtivoPaciente
                          : false) && (
                          <Button
                            label={
                              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span className="icon-galeria" />
                                {this.getConfiguredLabel(
                                  this.state.labelBotaoGaleria,
                                  'PORTAL.CARD.IMAGE_GALLERY',
                                  [
                                    'Galeria',
                                    'Galeria de imagens',
                                    'Galeria de Imagens',
                                    'Abrir Galeria',
                                    'Abrir galeria',
                                    'Abrir galeria de imagens',
                                    'Abrir Galeria de Imagens',
                                    'Image gallery',
                                    'Image Gallery',
                                    'Open gallery',
                                    'Open Gallery',
                                    'Open image gallery',
                                    'Gallery',
                                    'Galería',
                                    'Galería de imágenes',
                                    'Galería de Imágenes',
                                    'Abrir galería',
                                    'Abrir galería de imágenes',
                                  ]
                                )}
                              </span>
                            }
                            className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Galeria' ? 'buttom-modal-selected' : ''}`}
                            onClick={() => {
                              this.setState({ modalOpcaoSelecionada: 'Galeria' });
                              this.AdicionarHistoricoAcoes(
                                29,
                                this.state.pedidoModalOpcoes.Id,
                                this.state.pedidoModalOpcoes.Tipo
                              );
                            }}
                          />
                        )}

                        {this.mostrarBotaoLaudoNaModal(this.state.pedidoModalOpcoes) && (
                          <div>
                            {(isPerfilMedico
                              ? this.state.botaoLaudoAtivoMedico
                              : this.state.botaoLaudoAtivoPaciente) && (
                              <Button
                                label={
                                  <span
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span className="icon-laudo" />
                                    {this.state.labelBotaoLaudo || t('PORTAL.CARD.REPORT')}
                                  </span>
                                }
                                className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Laudo' ? 'buttom-modal-selected' : ''}`}
                                onClick={() => {
                                  this.setState({
                                    modalOpcaoSelecionada: 'Laudo',
                                    mostrarModalAcoesMobile: false,
                                  });

                                  this.abrirLaudo(this.state.pedidoModalOpcoes);

                                  this.AdicionarHistoricoAcoes(
                                    46,
                                    this.state.pedidoModalOpcoes.Id,
                                    this.state.pedidoModalOpcoes.Tipo
                                  );
                                }}
                              />
                            )}
                          </div>
                        )}

                        <div>
                          {(isPerfilMedico
                            ? this.state.botaoAnexosAtivoMedico
                            : this.state.botaoAnexosAtivoPaciente) && (
                            <Button
                              label={
                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <span className="icon-anexos" />
                                  {this.state.labelBotaoAnexos || t('PORTAL.CARD.ATTACHMENTS')}
                                </span>
                              }
                              visible={!this.state.existeAnexo}
                              className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Anexos' ? 'buttom-modal-selected' : ''}`}
                              onClick={() => {
                                this.setState({ modalOpcaoSelecionada: 'Anexos' });
                                this.AdicionarHistoricoAcoes(
                                  34,
                                  this.state.pedidoModalOpcoes.Id,
                                  this.state.pedidoModalOpcoes.Tipo
                                );
                              }}
                            />
                          )}
                        </div>

                        <div style={{ display: this.state.isExecutante ? 'block' : 'none' }}>
                          {this.RetPerfil() === 'Médico Executante' && (
                            <div>
                              {isPerfilMedico && this.state.botaoParecerAtivoMedico && (
                                <Button
                                  label={
                                    <span
                                      style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span className="icon-parecer" />
                                      {this.getConfiguredLabel(
                                        this.state.labelBotaoParecer,
                                        'PORTAL.CARD.MEDICAL_OPINION',
                                        [
                                          'Parecer médico',
                                          'Parecer Médico',
                                          'Visualizar Parecer',
                                          'Visualizar Parecer Médico',
                                        ]
                                      )}
                                    </span>
                                  }
                                  className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Parecer' ? 'buttom-modal-selected' : ''}`}
                                  onClick={() => {
                                    this.setState({ modalOpcaoSelecionada: 'Parecer' }, () => {
                                      const pedido = this.state.pedidoModalOpcoes;
                                      if (pedido?.Id) {
                                        const medicoService = new MedicoService();
                                        medicoService
                                          .GetParecerMedico(pedido.Id)
                                          .then(data => {
                                            const _listaParecer = data.Comentarios.map(el => ({
                                              DataCadastro: moment(el.DataCadastro).format(
                                                'DD/MM/YYYY'
                                              ),
                                              Prioridade: this.retLegendaPrioridade(el.Prioridade),
                                              Texto: el.Texto,
                                            }));
                                            this.setState({ listaParecer: _listaParecer });
                                            this.AdicionarHistoricoAcoes(
                                              33,
                                              this.state.pedidoModalOpcoes.Id,
                                              this.state.pedidoModalOpcoes.Tipo
                                            );
                                          })
                                          .catch(error => {
                                            console.log('Erro ao buscar parecer médico:', error);
                                          });
                                      }
                                    });
                                  }}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                  {(this.state.modalOpcaoSelecionada === 'Arquivos' ||
                    this.state.modalOpcaoSelecionada === 'Imagens') && (
                    <div className="ModalButtons">
                      {this.state.pedidoModalOpcoes?.Files?.length > 0 && (
                        <Button
                          label={
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <span className="icon-anexos" />
                              {t('PORTAL.EXTERNAL.FILES')}
                            </span>
                          }
                          className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Arquivos' ? 'buttom-modal-selected' : ''}`}
                          onClick={() => this.setState({ modalOpcaoSelecionada: 'Arquivos' })}
                        />
                      )}

                      {this.state.pedidoModalOpcoes.imagemPreviewUrl && (
                        <Button
                          label={
                            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <span className="icon-galeria" />
                              {t('PORTAL.EXTERNAL.IMAGES')}
                            </span>
                          }
                          className={`buttom-modal ${this.state.modalOpcaoSelecionada === 'Imagens' ? 'buttom-modal-selected' : ''}`}
                          onClick={() => this.setState({ modalOpcaoSelecionada: 'Imagens' })}
                        />
                      )}
                    </div>
                  )}

                  {(() => {
                    const { modalOpcaoSelecionada } = this.state;
                    const classes = ['ModalActions'];

                    if (
                      modalOpcaoSelecionada === 'Laudo' ||
                      modalOpcaoSelecionada === 'Compartilhar'
                    ) {
                      classes.push('ModalActionsLaudo');
                    }

                    if (modalOpcaoSelecionada === 'Exames externos') {
                      classes.push('ModalActionsExamesExternos');
                    }

                    if (modalOpcaoSelecionada === 'Compartilhar') {
                      classes.push('compartilhar');
                    }

                    if (modalOpcaoSelecionada === 'Arquivos') {
                      classes.push('arquivos');
                    }

                    return (
                      <div className={classes.join(' ')}>
                        <div>{this.renderAcoesDaModal(this.state.pedidoModalOpcoes)}</div>
                      </div>
                    );
                  })()}
                </div>
              )}

              {/* Área de conteúdo dinâmico */}
              <div
                className={`ModalVisualizador ${this.getClasseVisualizador()}`}
                style={
                  this.state.modalOpcaoSelecionada === 'Viewer'
                    ? { width: '98%', height: '85vh' }
                    : {}
                }>
                {this.renderConteudoModalGenerica()}
              </div>
            </div>
          )}
        </Dialog>
      </div>
    );
  }
  //#endregion
}

export default withNamespaces()(ScreensHomeForm);
